// tslint:disable:max-line-length
import { LanguageCode } from './i18n/config';
import { REPORT_KEYS } from './reports/report-keys.const';

export interface II18nBackendStrings {
  [key: string]: string;
}

export interface II18nReportsData {
  [key: string]: {
    categoryName: string;
    description: string;
    title: string;
  };
}

export type II18nThoughtSpotData = Record<LanguageCode, Record<string, string>>;

export interface II18nSingularPlural {
  [key: string]: {
    singular: string;
    plural: string;
  };
}

export interface II18nAppMarketplaceData {
  [key: string]: {
    guide: string;
    desc: string;
    detail: string;
    recommendedDescription: string | null;
    category: {
      desc: string;
      title: string;
    };
  };
}

export const GeofenceCategory: II18nBackendStrings = {
  'Uncategorized': $localize`Uncategorized`,
  'Fuel Station': $localize`Fuel Station`,
  'Job Site': $localize`Job Site`,
  'Maintenance Facility': $localize`Maintenance Facility`,
  'Receiver / Consignee': $localize`Receiver / Consignee`,
  'Restricted Location': $localize`Restricted Location`,
  'Shipper': $localize`Shipper`,
  'Shipper / Receiver': $localize`Shipper / Receiver`,
  'Terminal / Yard': $localize`Terminal / Yard`,
  'Truck Stop / Rest Area': $localize`Truck Stop / Rest Area`,
  'Weigh Station / Scale': $localize`Weigh Station / Scale`,
  'Spotted Lanternfly Zone': $localize`Spotted Lanternfly Zone`,
  'Risk Zone': $localize`Risk Zone`,
};

export const LoadBoard: II18nBackendStrings = {
  'Bid': $localize`Bid`,
  'Full': $localize`Full`,
  'Team': $localize`Team`,
  'CARB': $localize`CARB`,
  'TWIC': $localize`TWIC`,
  'Blind': $localize`Blind`,
  'Straps': $localize`Straps`,
  'Weight': $localize`Weight`,
  'Escorts': $localize`Escorts`,
  'Partial': $localize`Partial`,
  'Contact': $localize`Contact`,
  'Book Now': $localize`Book Now`,
  'Register': $localize`Register`,
  'Max Temp': $localize`Max Temp`,
  'Min Temp': $localize`Min Temp`,
  'Lift Gate': $localize`Lift Gate`,
  'Total Rate': $localize`Total Rate`,
  'Driver Work': $localize`Driver Work`,
  'Recommended': $localize`Recommended`,
  'Up to 28 ft': $localize`Up to 28 ft`,
  'Up to 48 ft': $localize`Up to 48 ft`,
  'Up to 53 ft': $localize`Up to 53 ft`,
  'Over 500 mi': $localize`Over 500 mi`,
  'Over 500 km': $localize`Over 500 km`,
  'Up to 100 km': $localize`Up to 100 km`,
  'Up to 100 mi': $localize`Up to 100 mi`,
  '54 ft and up': $localize`54 ft and up`,
  'HAZMAT Class': $localize`HAZMAT Class`,
  'Floor Loaded': $localize`Floor Loaded`,
  'See Comments': $localize`See Comments`,
  'Rate per Mile': $localize`Rate per Mile`,
  'Pre-cool Temp': $localize`Pre-cool Temp`,
  'Alcohol Permit': $localize`Alcohol Permit`,
  'Pallet Exchange': $localize`Pallet Exchange`,
  'Oversized Width': $localize`Oversized Width`,
  'Oversized Length': $localize`Oversized Length`,
  'Oversized Height': $localize`Oversized Height`,
  'Between 100-500 km': $localize`Between 100-500 km`,
  'Between 100-500 mi': $localize`Between 100-500 mi`,
  'Trailer Requirements': $localize`Trailer Requirements`,
  'Trip (Short to Long)': $localize`Trip (Short to Long)`,
  'Trip (Long to Short)': $localize`Trip (Long to Short)`,
  'Rec': $localize`Rec`,
  'Date/Time': $localize`Date/Time`,
  'Origin/Dest.': $localize`Origin/Dest.`,
  'DH-O/D': $localize`DH-O/D`,
  'Rate/Mile': $localize`Rate/Mile`,
  'Equipment': $localize`Equipment`,
  'Rate/Km': $localize`Rate/Km`,
};

export const AssetTypes: II18nBackendStrings = {
  'Van': $localize`Van`,
  'Tarp': $localize`Tarp`,
  'Other': $localize`Other`,
  'Stake': $localize`Stake`,
  'Tanker': $localize`Tanker`,
  'Drybox': $localize`Drybox`,
  'Lowboy': $localize`Lowboy`,
  'Reefer': $localize`Reefer`,
  'Flatbed': $localize`Flatbed`,
  'Hot Shot': $localize`Hot Shot`,
  'Conestoga': $localize`Conestoga`,
  'Container': $localize`Container`,
  'Livestock': $localize`Livestock`,
  'Step Deck': $localize`Step Deck`,
  'Power Only': $localize`Power Only`,
  'Double Drop': $localize`Double Drop`,
  'Auto Hauler': $localize`Auto Hauler`,
  'Dump/Tipper': $localize`Dump/Tipper`,
  'Construction': $localize`Construction`,
  'Curtain Side': $localize`Curtain Side`,
  'Intermodal Chassis': $localize`Intermodal Chassis`,
  'Tanker Endorsement': $localize`Tanker Endorsement`,
  'Removable Gooseneck (RGN)': $localize`Removable Gooseneck (RGN)`,
  'Straight/Box Truck': $localize`Straight/Box Truck`,
  'Sprinter Van': $localize`Sprinter Van`,
  'Heavy Haul': $localize`Heavy Haul`,
  'Driveaway': $localize`Driveaway`,
};

export const FleetView: II18nBackendStrings = {
  moving: $localize`Moving`,
  idle: $localize`Idle`,
  off: $localize`Off`,
  stale: $localize`Stale`,
  stationary: $localize`Stationary`,
  drivers: $localize`Drivers`,
  assets: $localize`Assets`,
  vehicles: $localize`Vehicles`,
  geofences: $localize`Geofences`,
  sb: $localize`SB`,
  on: $localize`ON`,
  d: $localize`D`,
  w: $localize`W`,
  all: $localize`All`,
  late: $localize`Late`,
  engaged: $localize`Engaged`,
  none: $localize`No Issues`,
  fault_codes: $localize`Fault Codes`,
};

export const AppMarketplace: II18nBackendStrings = {
  All: $localize`All`,
  TMS: $localize`TMS`,
  Fuel: $localize`Fuel`,
  Other: $localize`Other`,
  Safety: $localize`Safety`,
  Insurance: $localize`Insurance`,
  Visibility: $localize`Visibility`,
  Compliance: $localize`Compliance`,
  Navigation: $localize`Navigation`,
  Maintenance: $localize`Maintenance`,
};

export const AppMarketplaceCategoriesDescription: II18nBackendStrings = {
  visibility: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
  tms: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
  maintenance: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
  safety: $localize`Protect your fleet from the unpredictability of the road with enhanced safety measures.`,
  fuel: $localize`Seamlessly tie fuel card purchases to specific vehicles using driver location data for accurate reporting.`,
  compliance: $localize`Ensure that your fleet is compliant with critical government regulations.`,
  navigation: $localize`Launch routes and stops directly from the Motive mobile app to streamline driver navigation.`,
  insurance: $localize`Securely share Motive driver history to receive safe driving discounts.`,
  other: $localize`Extend the Motive platform through a variety of third-party applications.`,
  oem: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
};

export const AppMarketplaceData: II18nAppMarketplaceData = {
  'thermo-king': {
    guide: '',
    desc: $localize`Connect your Thermo King equipment to pull real time data into Motive Dashboard.`,
    detail: $localize`Connect your Thermo King equipment to pull real time data into Motive Dashboard.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'carrier': {
    guide: '<a href="https://helpcenter.gomotive.com/hc/en-us/articles/29722494106909-Carrier-Transicold-integration-with-Motive-Marketplace">' + $localize`How to connect your Carrier powered equipment to the Motive dashboard` + '</a>',
    desc: $localize`Connect your Carrier assets to pull real time data into Motive Dashboard.`,
    detail: $localize`Collect data directly from eligible Carrier assets with no hardware installation needed.`,
    recommendedDescription: $localize`Connect your Carrier assets to pull real time data into Motive Dashboard.`,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'jdlink-john-deere': {
    guide: `<ul> <li><a href="https://help.gomotive.com/s/articles/How-to-connect-your-John-Deere-powered-equipment-to-the-Motive-dashboard?language=en_US">` + $localize`How to connect your John Deere powered equipment to the Motive dashboard` + `</a></li>`,
    desc: $localize`Connect your JDlink John Deere equipment to pull real time data into Motive Dashboard.`,
    detail: $localize`View Equipment information with JDlink and use it to make informed decisions that boost productivity, lower costs, simplify maintenance, and improve safety on your jobsite. Collect data directly from your John Deere equipment with no hardware installation needed. Pull GPS location, engine hours, odometer, fuel level, and fault code readings from John Deere equipment. Leverage geofence alerts and reports for utilization, dormancy, and time on jobsite. Integration requires an active subscription to Motive and JDlink.`,
    recommendedDescription: $localize`Connect your JDlink John Deere equipment to pull real time data into Motive Dashboard.`,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'komtrax-komatsu': {
    guide: `<ul> <li><a href="https://help.gomotive.com/s/articles/How-to-connect-your-Komatsu-powered-equipment-to-the-Motive-dashboard?language=en_US">` + $localize`How to connect your Komatsu powered equipment to the Motive dashboard` + `</a></li>`,
    desc: $localize`Connect your Komtrax Komatsu equipment to pull real time data into the Motive Dashboard.`,
    detail: $localize`View Equipment information with Komtrax and use it to make informed decisions that boost productivity, lower costs, simplify maintenance, and improve safety on your jobsite. Collect data directly from your Komatsu equipment with no hardware installation needed. Pull GPS location, engine hours, odometer, fuel level, and fault code readings from Komatsu equipment. Leverage geofence alerts and reports for utilization, dormancy, and time on jobsite. Integration requires an active subscription to Motive and Komtrax.`,
    recommendedDescription: $localize`Connect your Komtrax Komatsu equipment to pull real time data into the Motive Dashboard.`,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'visionlink-cat': {
    guide: `<ul> <li><a href="https://help.gomotive.com/s/articles/How-to-connect-your-Caterpillar-powered-equipment-to-the-Motive-dashboard?language=en_US">` + $localize`How to connect your Caterpillar powered equipment to the Motive dashboard` + `</a></li>`,
    desc: $localize`Connect your Visionlink Caterpillar equipment to pull real time data into Motive Dashboard.`,
    detail: $localize`View Equipment information with VisionLink and use it to make informed decisions that boost productivity, lower costs, simplify maintenance, and improve safety on your jobsite. Collect data directly from your Caterpillar equipment with no hardware installation needed. Pull GPS location, engine hours, odometer, fuel level, and fault code readings from Caterpillar equipment. Leverage geofence alerts and reports for utilization, dormancy, and time on jobsite. Integration requires an active subscription to Motive and VisionLink.`,
    recommendedDescription: $localize`Connect your Visionlink Caterpillar equipment to pull real time data into Motive Dashboard.`,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'caretrack-volvo-construction': {
    guide: `<ul> <li><a href="https://help.gomotive.com/s/articles/How-to-connect-your-Volvo-Construction-powered-equipment-to-the-Motive-dashboard?language=en_US">` + $localize`How to connect your Volvo Construction powered equipment to the Motive dashboard` + `</a></li>`,
    desc: $localize`Connect your Caretrack Volvo construction equipment to pull real time data into the Motive Dashboard.`,
    detail: $localize`View Equipment information with Caretrack and use it to make informed decisions that boost productivity, lower costs, simplify maintenance, and improve safety on your jobsite. Collect data directly from your Volvo construction equipment with no hardware installation needed. Pull GPS location, engine hours, odometer, fuel level, and fault code readings from Volvo construction equipment. Leverage geofence alerts and reports for utilization, dormancy, and time on jobsite. Integration requires an active subscription to Motive and Caretrack.`,
    recommendedDescription: $localize`Connect your Caretrack Volvo construction equipment to pull real time data into the Motive Dashboard.`,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'convoy': {
    guide: $localize`Sign up and haul with Convoy today`,
    desc: $localize`Easily share your fleet\'s location data with Convoy, so that you can earn more with less hassle.`,
    detail: $localize`Easily share your fleet\'s location data with Convoy, so that you can earn more with less hassle.`,
    recommendedDescription: $localize`Easily share your fleet\'s location data with Convoy, so that you can earn more with less hassle.`,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'c-h-robinson': {
    guide: '',
    desc: $localize`Automatically provide tracking updates on your C.H. Robinson loads.`,
    detail: $localize`Automatically provide real-time tracking updates for C.H. Robinson loads. Tracking occurs during the life of the load, based on your pickup appointment time. Updates end upon departure from the receiver, which also automatically closes the load.<br><br>Use this integration to minimize (and possibly eliminate) manual check calls from your day. All location updates tracked with this app also post to the load on C.H. Robinson\'s Navisphere® Carrier platform, giving you and the end-customer quick, clear, and accurate visibility.`,
    recommendedDescription: $localize`Automatically provide tracking updates on your C.H. Robinson loads.`,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'fleetio-manage': {
    guide: $localize`Refer to the following document for helpful user information:
                      <ul>
                        <li>Motive Help Center Article (Coming Soon)</li>
                        <li>
                          <a href="https://help.fleetio.com/s/article/motive-integration?language=en_US" target="_blank">
                            Fleetio Help Center Article
                          </a>
                        </li>
                      </ul>`,
    desc: $localize`Capture odometer updates, fuel location exceptions, diagnostic faults, Motive Cards, and more.`,
    detail: $localize`Effortlessly connect Motive devices with Fleetio to streamline your fleet maintenance operations,
                      whether managed in-house or through third-party providers. For customers integrating Motive and
                      Fleetio, we’ve added two new settings to automate fuel transactions from your Motive Cards and
                      resolve DVIR defects in Motive when those issues are resolved in Fleetio.
                      <br/>
                      <h4>Key Benefits</h4>
                      When these features are enabled, they allow you to:
                        <ul>
                          <li>
                            <strong>Close the loop on maintenance—automatically:</strong>
                            When a maintenance issue generated from a Motive DVIR is resolved in Fleetio, the
                            corresponding DVIR defect is closed in Motive, mirroring inspection statuses across both
                            systems, reducing compliance risk, minimizing downtime, and keeping drivers, mechanics, and
                            managers in sync.
                          </li>
                          <li>
                            <strong>See the true cost of running your fleet:</strong>
                            Create fuel entries automatically for every Motive fuel card transaction, helping to
                            centralize fuel tracking and reporting alongside your other maintenance costs per asset,
                            giving you a single source of truth for budgeting, forecasting, and total cost of ownership.
                          </li>
                          <li>
                            <strong>Improve operational visibility:</strong>
                            Give your team instant access to the maintenance and fuel data they need to communicate
                            fleet needs across teams and keep clean and accurate records for compliance reporting.
                          </li>
                        </ul>
                        The Motive integration is available on all plans. <br />
                        <i>
                          <strong>Note:</strong> The Motive Card integration will only sync fuel transactions, and
                          Two-Way DVIR Defect Resolution is only available on Premium plans.
                        </i>`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'macropoint': {
    guide: '',
    desc: $localize`Visibility and predictive ETAs for shippers and LSP customers in real time.`,
    detail: $localize`MacroPoint with Motive provides real-time freight visibility, automated arrival and departure notifications, and predictive ETAs for shippers to improve customer service and reduce time spent responding to check calls.<br><br>Descartes MacroPoint provides pre-built integrations for over 40 TMS and carrier dispatch systems, including McLeod, Aljex, OTM, SAP, Manhattan Associates, JDA, and TMW.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'fourkites': {
    guide: '',
    desc: $localize`Track shipment locations and proactively manage exceptions.`,
    detail: $localize`Use FourKites to track shipment location to proactively manage exceptions. Using predictive analytics to calculate shipment arrival times, FourKites enables customers to lower operating costs, improve on-time performance, and strengthen end-customer relationships.<br><br>Using FourKites, blue-chip shippers and 3PLs share the same, real-time shipping location and status information from more than four million GPS/ELD devices, across all modes, including ocean, rail, parcel, and over-the-road. The platform is optimized for mobile and equipped with market-leading end-to-end security.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'shipwell': {
    guide: '',
    desc: $localize`Connect with shippers and 3PLs to get shipments, share tracking information, and automate dispatch.`,
    detail: $localize`Shipwell offers one central freight platform to quote, book, track, and manage freight shipments; ensure HOS compliance; maintain minute-by-minute GPS locations for tracking shipments; send instant updates and documentation for last-minute assignments, customer requests, or instructions; and manage driver profiles, vehicle assignments, and driver HOS.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  '10-4-systems': {
    guide: '',
    desc: $localize`Share status updates, visibility, and predictive ETAs.`,
    detail: $localize`10-4 gathers location data, asset updates, and order information from carriers and vendors to deliver full transparency into the lifecycle of each shipment. When a shipment is tendered to a carrier in 10-4, a shipment ID and a vehicle ID are assigned to the shipment. 10-4 requests location data for that vehicle ID from Motive only throughout the duration of that shipment. As soon as the shipment is delivered, 10-4 will no longer receive location data from that particular vehicle ID.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'project44': {
    guide: '',
    desc: $localize`Predictive, accurate tracking to ship more efficiently and provide greater customer  satisfaction. `,
    detail: $localize`Using project44\'s leading advanced visibility platform, shippers and 3PLs can connect, automate, and provide visibility into key transportation processes to accelerate insights and shorten the time it takes to turn those insights into actions. By ensuring carriers and their customers always have an accurate location updates and estimated shipment arrival times, project44 helps perfect the delivery experience and eliminate the need for costly and time-consuming phone calls to check in with drivers.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'truckstop-com': {
    guide: '',
    desc: $localize`Track assets and provide feedback to shippers without additional apps.`,
    detail: $localize`Truckstop.com streamlines asset tracking and shipper feedback. Using Motive location data, Truckstop.com Pro offers real-time visibility plus rate knowledge, route planning, and broker information.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'uber-freight': {
    guide: $localize`Detailed tracking instructions can be found ` +
      `<a href=\'https://uberfreight.zendesk.com/hc/en-us/articles/360049328993-Tracking-and-Location-Data-Sharing\'>` + $localize`here` + `</a>.`,
    desc: $localize`Enable hassle-free tracking to avoid check calls and unlock exclusive future benefits.`,
    detail: $localize`Uber Freight is the one app for every haul. Get access to upfront pricing, customized load suggestions, hassle-free booking, quick pay, and facility ratings to put you in the driver\'s seat. Connect your Motive ELD today to unlock exclusive benefits.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'uberfreight': {
    guide: $localize`Detailed tracking instructions can be found ` +
      `<a href=\'https://uberfreight.zendesk.com/hc/en-us/articles/360049328993-Tracking-and-Location-Data-Sharing\'>` + $localize`here` + `</a>.`,
    desc: $localize`Enable hassle-free tracking to avoid check calls and unlock exclusive future benefits.`,
    detail: $localize`Uber Freight is the one app for every haul. Get access to upfront pricing, customized load suggestions, hassle-free booking, quick pay, and facility ratings to put you in the driver\'s seat. Connect your Motive ELD today to unlock exclusive benefits.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'dat-ontime': {
    guide: '',
    desc: $localize`Seamlessly track assets and provide feedback to shippers while avoiding check calls.`,
    detail: $localize`DAT OnTime via your Motive Vehicle Gateway allows shippers and brokers to seamlessly track assets and provide feedback to carriers to avoid check calls without loading additional apps.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'copilot-truck': {
    guide: '',
    desc: $localize`\tQuickly send planned stops directly to truck-legal navigation for driver efficiency.`,
    detail: $localize`The CoPilot Truck integration with Motive allows users to send planned stops directly to truck-legal navigation. The only truck navigation powered by PC*MILER routing, CoPilot Truck provides drivers with an easy to use interface for accurate and reliable routing, so they can focus on what they do best - driving.<br><br>Users can launch CoPilot Truck directly from within Motive\'s mobile app, with the next stop already populated. Drivers can rest easy knowing they are headed to a Motive defined stop, while being safely and efficiently guided through truck-legal, turn-by-turn navigation.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Launch routes and stops directly from the Motive mobile app to streamline driver navigation.`,
      title: $localize`Navigation`,
    },
  },
  'edge-logistics': {
    guide: $localize`Once the carrier enables the integration, Edge will just need the assigned Truck # and our system will do the rest. The system will pull location updates every 15 minutes to track the driver and confirm whether they\'re on track for pick-up and delivery.`,
    desc: $localize`Automatically share location data to reduce costs and check in calls.`,
    detail: $localize`This integration provides Motive partners an easy and simple way to make their business with Edge more efficient. Location data is automatically uploaded every 15 minutes and stops as soon as the freight is delivered. This limits check calls and optimizes cost.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'shipchain': {
    guide: $localize`1. After entering you ShipChain account credentials, select integration options when prompted <br>\r\n2. Return to your ShipChain account and select the Devices screen from the side menu <br>\r\n3. Verify that all devices in your Motive account have been add to the ShipChain devices table <br>\r\n4. Create or edit a shipment to include the Motive\'s vehicle gateway as the tracking device <br>\r\n5. Pickup the shipment to begin recording tracking data <br>\r\n6. Drop-off the shipment to end tracking data recording <br>`,
    desc: $localize`End-to-end, multimodal cargo visibility for shippers, carriers, and customers.`,
    detail: $localize`ShipChain\'s powerful yet simple end-to-end visibility platform allows for a fully integrated and traceable supply chain: from the moment a shipment leaves a factory, to its final delivery with a customer.<br>As a ShipChain and Motive client, you\'re able to:<br><br><li>Pick up and deliver shipments in your organization with full transparency provided by the blockchain from the convenience of your smartphone</li><li>Monitor in-real-time, tracking updates simultaneously between web and mobile for any moving shipments</li><li>Upload signed documents, handling procedures, inventory lists, and shipment images with just a few taps</li><li>Share key shipment information and updates with the recipient through the life of the shipment</li><br>This integration allows Motive\'s GPS data to be added to the ShipChain ecosystem to provide a truly end-to-end track and trace.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'progressive': {
    guide: '',
    desc: $localize`Securely share driving data for special savings on insurance premiums.`,
    detail: $localize`Enjoy guaranteed savings of 3%, and as much as 18%, for drivers who have high safety records using Motive with Progressive. Fleets save an average of $1,384 on their insurance premiums.<br><br>Motive driver data is shared—with customer permission—with Progressive who provide custom quotes based on driving behavior.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Securely share Motive driver history to receive safe driving discounts.`,
      title: $localize`Insurance`,
    },
  },
  'mcleod-software': {
    guide: $localize`This integration requires professional services from McLeod and requires assistance from their Inside Sales team to enable the integration on your Motive account.`,
    desc: $localize`Integrate McLeod with Motive to dispatch drivers and enable bi-directional communication.`,
    detail: $localize`McLeod with Motive allows drivers and fleet managers to communicate directly through Motive\'s mobile app.<br><br>Dispatchers can assign loads to drivers effectively using drivers\' available time and vehicle location information within the McLeod system. Drivers can view dispatch information in the Motive Mobile App and check-in at various stops to provide dispatchers real-time updates.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'tmwsuite': {
    guide: $localize`This integration requires professional services from TMW and requires assistance from their Inside Sales team to enable the integration on your Motive account.`,
    desc: $localize`Streamline communication between dispatch and drivers.`,
    detail: $localize`TMWSuite is a transportation management software provider that specializes in routing, scheduling, and business intelligence.<br><br>Drivers can use the Motive app to manage dispatches, accept dispatches from TMWSuite, log progress, and submit relevant documents. These details are available for fleet managers to view in TMWSuite. Dispatches are seamlessly passed into the Motive app to ensure drivers have necessary information to deliver loads safely, efficiently, and without any HOS violations.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'prophesy-dispatch-a-korber-product': {
    guide: $localize`*This integration requires professional services from the Prophesy team and requires assistance from their sales team to enable the integration on your Motive account.<br><br>\r\n\r\n**Motive Enterprise package required. `,
    desc: $localize`Streamline communication between dispatchers and drivers with the Prophesy Dispatch and Motive integration.\r\n`,
    detail: $localize`Streamline communication between dispatchers and drivers with the Prophesy Dispatch and Motive integration. <br><br> \r\n\r\nDispatchers can assign loads to drivers by using the drivers\' available time and vehicle location information within the Prophesy Dispatch system to ensure a driver has enough available hours to complete a load. Drivers can use the Motive mobile app to view dispatch information and check-in to provide dispatchers with real-time updates at each stop, update goods information, and upload images that are automatically added to the load in the Prophesy Dispatch system. <br><br>Rolling ETA’s are created in Prophesy Dispatch with automatic position updates that are sent directly from the Motive app. If a load is running late, Prophesy Dispatch will notify the dispatcher with automatic alerts. \r\n`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'ascendtms': {
    guide: '',
    desc: $localize`Manage every aspect of your entire fleet and driver operations in real-time.`,
    detail: $localize`Comprehensively manage every aspect of your trucking operations with AscendTMS — from driver payroll to dispatch — to run a smarter, more efficient business. Enrich your transportation management with real-time driver location data from Motive to access jobs in AscendTMS immediately, and store vital fleet data in one unified platform.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'transport-pro': {
    guide: '',
    desc: $localize`Empower dispatches to make better decisions with real-time driver location & HOS data.`,
    detail: $localize`Transport Pro\'s integration with Motive provides asset customers with direct access to HOS information, truck locations, and messaging capabilities directly inside of Transport Pro\'s TMS.<br><br>Fleet admins can utilize various dashboards to see current information about the truck or driver, without having to leave the Transport Pro system.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'pegasys': {
    guide: $localize`Detailed setup instructions can be found at Pegasys University: ` +
      `<a href=\'https://pegasys.crisp.help/en-us/article/using-the-keeptruckin-integration-1f3ansq/\'>` +
      `https://pegasys.crisp.help/en-us/article/using-the-keeptruckin-integration-1f3ansq/</a>. <br><br>` +
      $localize`Or checkout our YouTube video: ` + '<a' +
      ' href=\'https://www.youtube.com/watch?v=h59TqwB3wi4\'>' + 'https://www.youtube.com/watch?v=h59TqwB3wi4</a>',
    desc: $localize`Supercharge your transportation management with real-time driver location & HOS data.`,
    detail: $localize`Using Pegasys and Motive, dispatchers can view up to the minute driver availability, location and status information. Combined with current asset utilization from the TMS, dispatchers can make better decisions about their fleet and strengthen relationships with customers by providing more accurate arrival times with real-time data from Motive.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'freight-visibility': {
    guide: $localize`Freight`,
    desc: $localize`Freight`,
    detail: $localize`Freight`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'ProTransport': {
    guide: $localize`Please contact your ProTransport account manager to get started.`,
    desc: $localize`View vehicle locations and hours of service data in ProTransport.`,
    detail: $localize`ProTransport will help you manage your daily operating needs within one, integrated system with customized technology solutions for accounting, dispatch, safety, maintenance, and more. View truck locations and driver hours of service in ProTransport based on real-time data from Motive.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'TruckLogics': {
    guide: $localize`Please contact our support center at 704.234.6956 or at support@trucklogics.com for additional assistance with completing initial setup.`,
    desc: $localize`Manage vehicles and generate IFTA reports based on ELD data with Motive integration.`,
    detail: $localize`Motive customers can now import all of their vehicle information and fuel data into TruckLogics and process IFTA returns in just a few clicks. With distance, fuel, and jurisdiction details, filing IFTA is a breeze.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`Fuel`,
    },
  },
  'innovative': {
    guide: '',
    desc: $localize`Keep the right teams in the right places with a fully integrated, intuitive dispatch experience.`,
    detail: $localize`With Innovative and Motive\'s integration, drivers and dispatchers can communicate directly through the Motive Driver app about their Innovative loads.\r\n\r\n<br><br>Load data is sent directly from Innovative to the driver’s Motive mobile app, and any changes made by the driver will automatically update in the Innovative system for a single source of truth across your dispatch data.\r\n\r\n<br><br>Hours-of-service details, load information, and remaining drive time from Motive are readily available in Innovative to help users better allocate and assign loads. Users can view drivers’ locations with real-time GPS data to ensure timely deliveries, and create workflow efficiencies that reduce manual data entry.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'ditat': {
    guide: $localize`This integration works in Ditat\'s platform offering hours of service information as well as asset location tracking.`,
    desc: $localize`Enhance your company\'s dispatching performance with Motive integration. Dispatch in confidence and dramatically reduce errors.`,
    detail: $localize`Integrate Motive with Ditat to fully utilize the platform. With Motive, Ditat provides a start to finish transportation management platform. Dispatching, asset tracking, and more are all available at your fingertips. With this integration, employees will make fewer mistakes and operate at higher efficiency levels.  Elevate your company\'s performance with Ditat!`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'speedgauge-safety-center': {
    guide: '',
    desc: $localize`Monitor vehicle speed and optimize fleet efficiency.`,
    detail: $localize`SpeedGauge with Motive leverages data collected by the Motive ELD to monitor vehicle speed and other driver behaviors that have direct impacts on safety and fleet efficiencies. Quickly and easily view fleet trend charts and reports delivered via email to optimize vehicles while they are on the road.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Protect your fleet from the unpredictability of the road with enhanced safety measures.`,
      title: $localize`Safety`,
    },
  },
  'drivewyze': {
    guide: $localize`Refer to the following documents for helpful user information:` + '\r\n<ul>\r\n<li><a' +
      ' href=\'https://drivewyze.com/keep-truckin-guide/\'>' + $localize`Digital Cab Card` + '</a></li>\r\n<li><a' +
      ' href=\'https://cdn.brandfolder.io/N99E3GYR/as/qdkiac-6cvlrs-5sgrsu/KeepTruckin_-_Promotional_Video.mp4\'>' +
      $localize`Driver Training Video` + `</a></li>\r\n<li><a href=\'https://bit.ly/2FZPsQg\'>` + $localize`Coverage Map` + `</a></li>\r\n</ul>`,
    desc: $localize`Bypass weigh stations straight from the in-cab device you’re using to run Motive - no transponder required. Start a free trial.`,
    detail: $localize`The Drivewyze PreClear weigh station bypass service is now available for Motive users!<br><br> \r\n\r\nDrivewyze PreClear is North America’s largest weigh station bypass service, and runs on the same smartphone, tablet, or other in-cab device that you are using to run Motive. As the largest weigh station bypass network in North America, PreClear offers weigh station bypass opportunities across 47 states and provinces.<br><br> \r\n\r\n\r\nAs a special limited time offer for Motive customers, your entire fleet can try out the full version of Drivewyze PreClear weigh station bypass at no cost and no risk, for 60 days. If you\'re interested in learning more about Drivewyze PreClear, or are ready to get started with the service, simply click the \'Get This App\' button on this page and we\'ll be in touch right away.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Protect your fleet from the unpredictability of the road with enhanced safety measures.`,
      title: $localize`Safety`,
    },
  },
  'otr-capital': {
    guide: '',
    desc: $localize`Quick, easy, and reliable payments with industry leading factoring from OTR Capital.`,
    detail: $localize`Using driver location data collected from Motive, OTR Capital can now validate the exact time and location a load is delivered to ensure you have a quick, easy, and reliable payment experience—and that you receive your profits immediately. The OTR Capital app can also streamline daily tasks like submitting invoices from jobs, requesting fuel advances, and checking customer credit.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'trakopolis': {
    guide: '',
    desc: $localize`Acquire, track, and analyze all operational data generated from your fleets\' assets.`,
    detail: $localize`Trakopolis combines the Internet of Things (IoT), telematics and a powerful API to create intuitive dashboards that give insight into core business operations, such as fleet management, equipment utilization, maintenance and repair scheduling, employee health and safety.<br><br>Trakopolis and Motive allow you to track all your companies\' assets—inclusive of fleet management, ELDs, equipment and workers—for key operational insights. See specific sensor information, advanced analytics, and lone worker applications alongside your existing Motive data to make more effective business decisions.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'comdata-ifta-tax-services': {
    guide: $localize`A Motive Pro subscription is required. Motive will enable automatic vehicle data upload to Comdata Fuel Tax Services.`,
    desc: $localize`Upload GPS data and odometer readings for simplified IFTA filings.`,
    detail: $localize`GPS data and odometer readings are automatically uploaded from your Motive Vehicle Gateway device to ensure accurate mileage data in Comdata\'s software. Depending on the fuel card provider, fuel purchase transactions can be manually included or automatically incorporated for Comdata fuel card purchases. The result is integrated monthly fuel purchase and  mileage data for simplified and automated IFTA filings.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Seamlessly tie fuel card purchases to specific vehicles using driver location data for accurate reporting.`,
      title: $localize`Fuel`,
    },
  },
  'truckeservices': {
    guide: '',
    desc: $localize`Aggregate fuel reports and mileage data for simplified IFTA reporting.`,
    detail: $localize`TRUCKeSERVICES will pull your mileage data from Motive, combine it with your fuel receipts, check it all for audit flags, and provide you with the reports you need to run your business.<br><br>The ability to aggregate fuel reports and mileage—with audit flags included—can save your fleet hours of manual data entry, error checking, and IFTA calculations.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Seamlessly tie fuel card purchases to specific vehicles using driver location data for accurate reporting.`,
      title: $localize`Fuel`,
    },
  },
  'ProMiles': {
    guide: $localize`Data received from Motive via API, processed and posted to a FuelTaxOnline account for review.`,
    desc: $localize`Automated fuel tax reporting for accurate, compliant trip records.`,
    detail: $localize`Automated fuel tax reporting available through FuelTaxOnline® combines the accuracy of Motive\'s GPS data with the power and experience of ProMiles to produce accurate, compliant trip records for IFTA/IRP use.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Seamlessly tie fuel card purchases to specific vehicles using driver location data for accurate reporting.`,
      title: $localize`Fuel`,
    },
  },
  'wex-efs-fuel-tax-services': {
    guide: '',
    desc: $localize`Process mileage and fuel purchase data in real-time for simplified tax reports.`,
    detail: $localize`Save time and improve efficiency by seamlessly compiling your mileage and fuel purchase data for easy fuel tax submission. By integrating your Motive GPS data to the WEX/EFS system along with your fuel purchase data, you can generate ready to submit fuel tax reports in real-time.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Seamlessly tie fuel card purchases to specific vehicles using driver location data for accurate reporting.`,
      title: $localize`Fuel`,
    },
  },
  'lytx-rair-compliance-services': {
    guide: '',
    desc: $localize`Aggregate compliance information across multiple technology providers.`,
    detail: $localize`Lytx-RAIR Compliance Services are fully integrated to help DOT-regulated fleets comply with safety regulations.<br><br>Lytx can pull Motive\'s Vehicle Gateway data —in addition to any other providers your fleet may be using—to offer a single, integrated, online HOS tracking system that helps identify compliance risk and address it.<br><br>Aggregating compliance data from the multiple technology providers used within your fleet empowers your business to better manage its CSA, driver logs, and qualification files to improve safety, reduce risk and operate more efficiently.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Ensure that your fleet is compliant with critical government regulations.`,
      title: $localize`Compliance`,
    },
  },
  'mvrcheck-eld-manager': {
    guide: '',
    desc: $localize`Simplify accessibility to driver information to keep your fleet safe and compliant.`,
    detail: $localize`MVRcheck.com provides instant DOT compliant Driving Records, PSP Records, DOT Drug Testing and Driver Qualification File Management services.<br><br>Using Motive\'s Vehicle Gateway data, MVRcheck.com allows users to keep their fleets safe and compliant at all times.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Ensure that your fleet is compliant with critical government regulations.`,
      title: $localize`Compliance`,
    },
  },
  'our-safety-department': {
    guide: '',
    desc: $localize`Elevate your safety and compliance programs through automated checks and balances.`,
    detail: $localize`Our Safety Department automates and manages your DOT driver files, equipment files, drug & alcohol testing programs, and accident register to keep your fleet safe and compliant at all times.<br><br>Using Motive\'s Vehicle Gateway data, our Safety Department can perform automated log audits, DOT mandated driver meaningful action (driver coaching), and DOT mandated falsification audits—all without any additional headcount.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Ensure that your fleet is compliant with critical government regulations.`,
      title: $localize`Compliance`,
    },
  },
  'rta-fleet-management-software': {
    guide: $localize`RTA will retrieve Motive odometer data nightly and automatically import that data.`,
    desc: $localize`Drive preventative maintenance schedules with RTA and Motive odometer data.`,
    detail: $localize`Seamlessly integrate Motive devices with RTA Fleet Management Software. Automatically sync with Motive odometers to drive RTA preventative maintenance schedules, ensure accurate records, and eliminate manual data entry.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'ZenduMaintenance': {
    guide: $localize`Once the connection has been established, diagnostic faults, engine hours, odometer, rule violation, and driver vehicle inspection reports are auto-synced. Also, corrective and scheduled maintenance work orders are automatically generated based on synced telematics data.`,
    desc: $localize`CMMS software that organizes, tracks, and schedules your maintenance activities.`,
    detail: $localize`Run your maintenance operation efficiently with preventative maintenance scheduling, inventory management, purchasing, custom reporting & maintenance cost accounting tools. ZenduMaintenance and Motive streamline maintenance workflows by automatically creating work orders using engine faults, driver vehicle inspection logs, engine hours, or odometer updates.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'tmt-fleet-maintenance': {
    guide: '',
    desc: $localize`Keep your vehicles on the road with an integrated maintenance experience.`,
    detail: $localize`TMT’s integration with Motive allows mutual customers to keep equipment running smoothly via timely and accurate odometer updates. These updates directly feed preventative maintenance schedules, so fleets can effectively manage equipment and avoid costly breakdowns.<br><br>Fault codes synced between Motive and TMT ensure constant connectivity with vehicle health so fleets can make time-sensitive repair decisions before they become major breakdowns. Any defects detected via Motive’s DVIRs are automatically pulled into the TMT platform. Once corrected and signed off by a mechanic, those updates are automatically pushed to Motive and TMT to minimize downtown and optimize efficiency.<br><br>The integration also enables a one-way vehicle and driver sync so that when a new unit or driver is added in Motive, a new unit or employee record is created in TMT.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'fleet-service-monitoring-system': {
    guide: $localize`Your service dealer will contact you when there\'s a need for maintenance on your trucks.`,
    desc: $localize`Allow your service dealer to monitor your vehicles for any fault codes or maintenance due.`,
    detail: $localize`ITOCHU\'s FSMS uses data received from Motive to notify your service dealer of your vehicle\'s conditions. You will be notified of any fault codes or periodical maintenance due from the odometer information. Avoid paying unnecessary maintenance costs by having the service professionals always be on top of your vehicles.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'crum-forster': {
    guide: $localize`Motive <b>Pro</b> or <b>Enterprise</b> subscription is required for this integration.`,
    desc: $localize`Seamlessly share driving data to save on insurance premiums.`,
    detail: $localize`Crum & Forster offers potential savings to auto liability customers that share their Motive data. For more information about this program, please click ` +
      '<a' + ' href="https://urldefense.proofpoint.com/v2/url?u=https-3A__truckercloud.com_program_CFTransportation&d=DwMFaQ&c=o3ygSuR1iZdItwjN5QxZUQCYAwJPm9xVcswOmaP6qpc&r=x6T854wT8jb6m4EOAeyHsgXIgc-0jkFLG-SRl0IOT9w&m=_74hlrxzksFY4G83uvFYA-Jb74XMOLTZGbFRMjFEB5E8IPtv6wuPQ8jtmJcs_-w8&s=pHz_Yan0FXyi9fLn707xWH5EGmgLd1gjkC2QRce77Mc&e=">' + $localize`here` + '</a>, ' +
      'email ' + '<a' + ' href="mailto:transportation.engineering@cfins.com">' + 'transportation.engineering@cfins.com' + '</a>' + $localize` or call 469-404-5511.<br><br>` +
      $localize`By clicking “Get This App” and installing this App, you agree to the terms of Crum & Forster’s Terms of ` +
      '<a' + ' href="https://urldefense.proofpoint.com/v2/url?u=https-3A__s3.amazonaws.com_com.cfins.public.resources_cfins_terms-2Dand-2Dconditions_index.html&d=DwMFaQ&c=o3ygSuR1iZdItwjN5QxZUQCYAwJPm9xVcswOmaP6qpc&r=x6T854wT8jb6m4EOAeyHsgXIgc-0jkFLG-SRl0IOT9w&m=_74hlrxzksFY4G83uvFYA-Jb74XMOLTZGbFRMjFEB5E8IPtv6wuPQ8jtmJcs_-w8&s=9-1jA8Rx-_UkKrqg2Dvs-nzyy2Vd7oKiw0mJ88nrRkA&e=">' + $localize`Third-Party Software` + '</a>' +
      $localize` Use and` +
      '<a' + ' href="https://urldefense.proofpoint.com/v2/url?u=https-3A__www.cfins.com_onlineprivacypolicy_&d=DwMFaQ&c=o3ygSuR1iZdItwjN5QxZUQCYAwJPm9xVcswOmaP6qpc&r=x6T854wT8jb6m4EOAeyHsgXIgc-0jkFLG-SRl0IOT9w&m=_74hlrxzksFY4G83uvFYA-Jb74XMOLTZGbFRMjFEB5E8IPtv6wuPQ8jtmJcs_-w8&s=pTN-0sHtz6QbbnMAOTWmMGdvz57gsSAi3xQ-SE1WBmE&e=">' + $localize` Privacy Policy` + '</a>.',
    recommendedDescription: null,
    category: {
      desc: $localize`Securely share Motive driver history to receive safe driving discounts.`,
      title: $localize`Insurance`,
    },
  },
  'Truckertools': {
    guide: $localize`Once the integration is complete, when a carrier’s MC number and vehicle ID are booked on a load for a Trucker Tools broker customer, the load will automatically start tracking 4 hours prior to the scheduled pickup time until delivery. The assigned vehicle’s latest location and corresponding time will be provided to the broker on the load.`,
    desc: $localize`Easily track on loads for brokers to meet visibility requirements and boost compliance.`,
    detail: $localize`Connect your Motive devices with Trucker Tools to provide tracking on loads through Trucker Tools for some of the largest and most popular brokers. By integrating your ELDs, you are connecting to hundreds of brokers and can automatically, successfully, and securely track on loads you haul. This integration also allows you to provide accurate and consistent tracking, which will make you an ideal and preferred carrier for brokers.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'MacroPoint': {
    guide: '',
    desc: $localize`Visibility and predictive ETAs for shippers and LSP customers in real time.`,
    detail: $localize`MacroPoint with Motive provides real-time freight visibility, automated arrival and departure notifications, and predictive ETAs for shippers to improve customer service and reduce time spent responding to check calls.<br><br>Descartes MacroPoint provides pre-built integrations for over 40 TMS and carrier dispatch systems, including McLeod, Aljex, OTM, SAP, Manhattan Associates, JDA, and TMW.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with logistics, shipping, and brokerage platforms to enable load monitoring and tracking with real-time location visibility for all Motive carriers.`,
      title: $localize`Visibility`,
    },
  },
  'ford-pro': {
    guide: '<li>Integration requires an active ENT subscription to Motive and Ford Pro.</li>\r\n<li>Available in the United States and Canada.</li>\r\n<li>To set up, <a href="https://helpcenter.gomotive.com/hc/en-us/articles/17728453011485-Ford-Pro-integration-with-Motive-App-Marketplace">Ford Pro integration with Motive App Marketplace</a></li>',
    desc: $localize`Seamlessly integrate vehicle data from 2020+ Ford models into Motive\'s centralized fleet management system, unlocking critical insights without hardware installation requirements.`,
    detail: $localize`Our industry-leading remote diagnostics solution supports 2020+ Ford vehicle models equipped with Ford Pro, transforming vehicle data into critical insights that enhance productivity, reduce costs, streamline maintenance, and bolster safety. \r\n\r\nAccess valuable vehicle insights through Ford Pro and seamlessly gather data from your Ford vehicles, extracting GPS location, engine hours, odometer, fuel level, and fault code readings into Motive\'s centralized fleet management system. Motive serves as the source of truth, eliminating the need for additional hardware and ensuring unified fleet management.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Integrate with Original Equipment Manufacturers (OEM) to enable real-time location tracking, and operating data from OEM vehicles and assets into your Motive fleet.`,
      title: $localize`OEM`,
    },
  },
  'CSI': {
    guide: 'A multi-threaded background windows service enables all facets of the Motive system.',
    desc: $localize`Build and assign loads in CSI.Road and dispatch them to the Drivers’ Motive device, in order to streamline communication between drivers and dispatchers.`,
    detail: $localize`Drivers respond to loads via onboard unit which updates CSI.Road Dispatch system automatically.\r\nDispatchers can dynamically assign the next load, with constant updates of drivers’ available hours.\r\nIncorporate electronic documents with your automated billing process directly after delivery and get paid the next day.\r\nEliminates the need for Spreadsheets or Paper processing, everything is electronically passed between Dispatch to Driver to Customer seamlessly.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'kamion': {
    guide: '',
    desc: $localize`Kamion is an intelligent TMS that helps dispatchers, accounting and safety make better decisions. Our goal is to help you reduce your back office expenses.`,
    detail: $localize`Kamion is an intelligent TMS that helps dispatchers, accounting and safety make better decisions. Our goal is to help you fill your trucks at better rates and reduce your back office expenses. Our easy Motive integration combines ELD data with our proprietary notification system to drive your profitability. \r\n\r\n\r\nNotable features include "automated driver schedule management and tracking, instant truck availability sharing, automated statements and invoicing, automatic safety reminders, fleet & dispatch reports, lane pricing insights".\r\n\r\n\r\nKamion gives you the tools you need to be smarter and more efficient. Take your Keep Truckin subscription to the next level and give your team superpowers.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'smartboard': {
    guide: '',
    desc: $localize`Enable dispatchers to make better and more informed decisions with real-time driver location and HOS data.`,
    detail: $localize`SmartBoard TMS is a complete, all-in-one, cloud-based solution designed to help you run your trucking company by connecting all your operations from safety, dispatch, maintenance, accounting, and more in one place. \r\nSmartBoard\'s integration with Motive allows dispatchers to view real-time driver locations and HOS data. Fleet managers have access to various dashboards to see real-time data about the truck or driver and calculate the remaining miles and time needed to arrive at the scheduled pick-up and delivery locations without having to leave SmartBoard.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'transplus': {
    guide: '',
    desc: $localize`Integrate TransPlus with Motive to dispatch drivers and enable bi-directional communication.`,
    detail: $localize`The integration supports two-way messaging with the driver and GPS updates.  HOS data is integrated into the TMS and used for planning.  Workflow automatically updates arrive/depart stop times in the TMS.  The driver can be prompted for required information at specific stops and the necessary images can be automatically indexed into the document imaging module.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'otm': {
    guide: 'Required Motive Subscription Required\r\n<ul>\r\n        <li>Enterprise</li>\r\n</ul>\r\nRefer to the following document for helpful user information:\r\n <ul>\r\n        <li><a href="https://helpcenter.gomotive.com/hc/en-us/articles/18524498812701-How-to-enable-JustDrive-with-NICO-integration" target="_blank">Help Center Article</a></li>\r\n</ul>',
    desc: $localize`Oracle Transportation Management (OTM) simplifies global transportation logistics, optimizing efficiency and connectivity across supply chains for cost-effective and seamless operations.`,
    detail: $localize`Oracle Transportation Management (OTM) provides a single platform for companies to manage all transportation activity throughout their supply chains. The solution allows companies to:\r\n    <ul>\r\n        <li>Minimize cost</li>\r\n        <li>Optimize service levels</li>\r\n        <li>Create flexible business process automation within their global transportation and logistics networks.</li>\r\n    </ul>\r\n\r\nDesigned to support the needs of both shippers and logistics service providers (LSPs), OTM creates an information bridge across:\r\n    <ul>\r\n        <li>Functional silos</li>\r\n        <li>Geographic regions</li>\r\n        <li>Languages</li>\r\n        <li>Currencies</li>\r\n        <li>Business units</li>\r\n    </ul>\r\n\r\nOTM supports customers from basic transportation needs to highly complex logistics requirements.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`TMS`,
    },
  },
  'ITOCHU-Fleet-Service-Monitoring-System': {
    guide: 'Your service dealer will contact you when there\'s a need for maintenance on your trucks.',
    desc: $localize`Allow your service dealer to monitor your vehicles for any fault codes or maintenance due.`,
    detail: $localize`ITOCHU\'s FSMS uses data received from Motive to notify your service dealer of your vehicle\'s conditions. You will be notified of any fault codes or periodical maintenance due from the odometer information. Avoid paying unnecessary maintenance costs by having the service professionals always be on top of your vehicles.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'holman-formerly-ari': {
    guide: 'This integration is available for all Motive customers who are subscribed to Holman (Formerly ARI). Please connect with your Holman representative for further guidance on enabling this integration.',
    desc: $localize`Incorporate essential telematics information from Motive into Holman to optimize your fleet operations and efficiently control expenses.`,
    detail: $localize`Incorporate essential telematics information from Motive into Holman to optimize your fleet operations and efficiently control expenses. <br><br>The key data elements being transferred from Motive platform into Holman are as follows:<br><br><ul><li>Synchronize your vehicles into Holman</li><li>Synchronize vehicle GPS, odometer and engine hours</li></ul>`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get complete fleet visibility and manage day-to-day operations, fault codes, and fuel location exception reporting.`,
      title: $localize`Maintenance`,
    },
  },
  'permitax': {
    guide: 'A Motive "Starter" or above subscription is required to use this app, and you must be a Permitax customer (a separate agreement is required).',
    desc: $localize`Automate the IFTA fuel tax reporting process using GPS data, ECM data, and fuel data.`,
    detail: $localize`Simplify IFTA Fuel Tax reporting by automating the processes using Motive GPS data, ECM  odometer data, fuel data, and toll data. Permitax provides an easy and cost-effective end-to-end solution. Unique and specialized data analysis and managed exceptions provide highly accurate reporting. An extensive set of reports are available. Permitax is a Canadian company with over 40 years of experience.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`Fuel`,
    },
  },
  'wex-efs-fuel-purchase': {
    guide: 'A Motive Pro or Enterprise subscription is required to use this app, and you must be a WEX/EFS customer.<br><br>\r\n\r\nAlso, you will need to go to the WEX/EFS website to fill out the "data sharing" instructions for Motive. Please find the instruction on how to do so by clicking <a href="https://drive.google.com/file/d/1kgou48YbBniR8kS4TvI0vYXmZ4TAtLzQ/view?usp=sharing">here</a>.',
    desc: $localize`This integration with EFS will automatically pull your EFS card transaction data into Motive.`,
    detail: $localize`Motive - WEX/EFS Fuel purchase integration automatically pulls your EFS card transaction data into Motive versus the manual spreadsheet upload. This data is currently used for the IFTA Summary Page and Fuel Purchases Page.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Get up-to-the-minute visibility by leveraging Motive\'s Driver Workflow feature to enable updates and real-time communication with TMS dispatch modules.`,
      title: $localize`Fuel`,
    },
  },
  'the-hartford': {
    guide: '',
    desc: $localize`Get more out of your telematics investment by partnering with The Hartford.`,
    detail: $localize`The Hartford is committed to safety, and one of the best technologies available for managing your fleet and driver safety is vehicle telematics. Get more out of your telematics investment by partnering with The Hartford. We offer a wide range of tailored services, whether you are interested in reducing fraudulent claims, investing to improve in-cab driver behaviors, or looking to save costs through mileage-based insurance.  <br><br>Click “Get This App” to get more out of your telematics investment with The Hartford.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Securely share Motive driver history to receive safe driving discounts.`,
      title: $localize`Insurance`,
    },
  },
  'northland-telematics-program': {
    guide: '',
    desc: $localize`Northland has developed a telematics program for trucking customers to help improve safety and efficiency by leveraging the evolution of data analytics.`,
    detail: $localize`Northland believes telematics is an indispensable tool that provides real-time drive performance data through wireless transmission to increase trucking safety while reducing costs. With leading telematics partners, we can deliver a full range of services to our trucking customers, focusing on accident prevention and driver performance.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Securely share Motive driver history to receive safe driving discounts.`,
      title: $localize`Insurance`,
    },
  },
  'qeo': {
    guide: '',
    desc: $localize`Securely share your driving data with QEO Insurance Group`,
    detail: $localize`QEO’s commercial transportation insurance coverages are designed for the energy, local delivery and the construction industries. QEO provides personalized service, focused on a quick response for our independent agents and their insureds. No account is too small, and no submission is too late. Our employees are always ready to assist.`,
    recommendedDescription: null,
    category: {
      desc: $localize`Securely share Motive driver history to receive safe driving discounts.`,
      title: $localize`Insurance`,
    },
  },
  'platformscience': {
    guide: $localize`For further information please <a href="https://www.platformscience.com/contact">contact us</a>`,
    desc: $localize`Our configurable platform delivers modern telematics, enterprise-grade applications, and future-proof fleet management solutions`,
    detail: $localize`Platform Science is a telematics and fleet management solutions provider connecting enterprise fleets, partners, and developers with the technology they need to create a better driving experience. Using an open platform designed to drive innovation, Platform Science offers a full suite of tools for developing, deploying, and managing the devices and apps that keep the transportation industry moving forward.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'intuit-quickbooks-online-beta': {
    guide: '',
    desc: $localize`Automatically sync your drivers\' HOS data with Quickbooks online.`,
    detail: $localize`The integration between Motive and QuickBooks Online facilitates the automatic synchronization of Drivers and Hours of Service data, simplifying payroll processing. \r\n<ul>\r\n<li>Intuit Quickbooks Online integration with Motive syncs drivers and HOS data between the two systems.</li> \r\n<li>The integration imports drivers from QuickBooks and creates their profiles in Motive. </li>\r\n<li>Using the driver information, the integration exports driver HOS data to QuickBooks to facilitate payroll processing for the drivers.</li>\r\n</ul>\r\n<br><br><b>Activation and Set-Up Steps:</b>\r\n<br>To request the integration, please install the application. We\'ll get in touch with you to guide you through the process.`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'workday': {
    guide: $localize`To request the integration, please click on the "<b>Install</b>" button. \r\n`,
    desc: $localize`Workday integration is a one-way integration that synchronizes user profiles with Workday.`,
    detail: $localize`<p>Workday integration is a one-way integration that uses workday data to synchronize user profiles. Workday workers are integrated into Motive, and user profiles are kept up to date. When a user\'s status is changed in Workday, it is also replicated in Motive. Furthermore, the integration manages the user groups based on Workday data such as organisation, location, job profile, and cost centre.  </p>\r\n\r\n<p>User provisioning workflows supported by the integration includes creating new users, updating current users, deactivating users, and assigning groups to users. User group provisioning operations supported by the integration includes creating a new user group, updating an existing group, and deleting a group. </p>\r\n\r\n<p>Please note that the integration requires read access to workday services in order to retrieve workers and organisation data.</p>\r\n\r\n`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'mygeotab': {
    guide: '',
    desc: $localize`Connect Motive’s best-in-class driver safety solution with Geotab Platform.`,
    detail: $localize`Motive and Geotab have partnered to connect Motive’s best-in-class driver safety solution with Geotab’s telematics platform.<ul><li>Easy access to both tools in one tab with single sign-on (SSO). Quickly navigate between Motive and Geotab features with built-in iframe.</li><li>Identify who’s driving from a single app.</li><li>Monitor and protect drivers with Motive’s industry defining AI, give safety managers the tools they can trust to prevent accidents and reduce risk.</li><li>Track important driver and vehicle data, including trip times, fuel consumption and maintenance updates.</li></ul>`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
  'ukg-preview': {
    guide: '',
    desc: $localize`The application aims to synchronize driver data from UKG to Motive and corresponding logs/timecards from Motive to UKG as punches.`,
    detail: $localize`This application aims to sync Drivers from UKG to Motive and their respective logs/timecards information from Motive as Punches in UKG. This integration includes 2 workflows:<br>\r\nUser/Driver Sync: In this workflow, integration will call UKG APIs to get users and create or update only Drivers (exempt as well as non-exempt) from those users in Motive through Motive Public APIs.<br>\r\nLogs/Timecards Sync: In this workflow, Integration will call Motive’s logs (for non-exempt drivers) and timecards (for exempt drivers) APIs to get the working hours information and send this as a punch in and punch out data to UKG through punches API.<br><br>\r\nFollowing are the subscription details:<br>\r\nUKG Subscription: UKG Pro WFM<br>\r\nMotive Subscription: Starter/Pro/Enterprise`,
    recommendedDescription: '',
    category: {
      desc: $localize`Extend the Motive platform through a variety of third-party applications.`,
      title: $localize`Other`,
    },
  },
};

export const Reports: II18nBackendStrings = {
  'Auto Hauler': $localize`Auto Hauler`,
  'Construction': $localize`Construction`,
  'Curtain Side': $localize`Curtain Side`,
  'Drybox': $localize`Drybox`,
  'Dump/Tipper': $localize`Dump/Tipper`,
  'Flatbed': $localize`Flatbed`,
  'Intermodal Chassis': $localize`Intermodal Chassis`,
  'Lowboy': $localize`Lowboy`,
  'Livestock': $localize`Livestock`,
  'Reefer': $localize`Reefer`,
  'Step Deck': $localize`Step Deck`,
  'Stake': $localize`Stake`,
  'Tanker': $localize`Tanker`,
  'Box Truck': $localize`Box Truck`,
  'Double Drop': $localize`Double Drop`,
  'Dry Van': $localize`Dry Van`,
  'Removable Gooseneck': $localize`Removable Gooseneck`,
  'Conestoga': $localize`Conestoga`,
  'Other': $localize`Other`,
  'Tires': $localize`Tires`,
  'AC & Heater': $localize`AC & Heater`,
  'Registration Expiry': $localize`Registration Expiry`,
  'Battery': $localize`Battery`,
  'Brakes': $localize`Brakes`,
  'Spark Plugs': $localize`Spark Plugs`,
  'Axles': $localize`Axles`,
  'Engine': $localize`Engine`,
  'Filter': $localize`Filter`,
  'Lease Expiry': $localize`Lease Expiry`,
  'Lights & Electrical': $localize`Lights & Electrical`,
  'Oil Change': $localize`Oil Change`,
  'In-Field': $localize`In-Field`,
  'Allocated': $localize`Allocated`,
  'RMA Active': $localize`RMA Active`,
  'Tractor': $localize`Tractor`,
  'Trailer': $localize`Trailer`,
  'Success': $localize`Success`,
  'Pending': $localize`Pending`,
  'Failure': $localize`Failure`,
  'Connected': $localize`Connected`,
  'Disconnected': $localize`Disconnected`,
  'Breadcrumb': $localize`Breadcrumb`,
  'Engine stop': $localize`Engine stop`,
  'Engine start': $localize`Engine start`,
  'Vehicle moving': $localize`Vehicle moving`,
  'Vehicle stopped': $localize`Vehicle stopped`,
  'Star Report': $localize`Star report`,
  'Unstar Report': $localize`Unstar report`,
  'I declare that this vehicle has been inspected in accordance with the applicable requirements.': $localize`I declare that this vehicle has been inspected in accordance with the applicable requirements.`,
  'Air Lines': $localize`Air Lines`,
  'Audio/Visual Equipment Battery': $localize`Audio/Visual Equipment Battery`,
  'AG-type flatbed': $localize`AG-type flatbed`,
  'Doors': $localize`Doors`,
  'AG-Type other': $localize`AG-Type other`,
  'ATN-D4V-2V3 Trailer-2': $localize`ATN-D4V-2V3 Trailer-2`,
  'Air Compressor': $localize`Air Compressor`,
  'Windshield Wiper Fluid': $localize`Windshield Wiper Fluid`,
  'Exhaust System': $localize`Exhaust System`,
  'Registation Expiry': $localize`Registation Expiry`,
  'Hitch': $localize`Hitch`,
  'Defroster': $localize`Defroster`,
  'Service Brakes': $localize`Service Brakes`,
  'Part K1': $localize`Part K1`,
  'Belts & Hoses': $localize`Belts & Hoses`,
  'Tire': $localize`Tire`,
  'Body': $localize`Body`,
  'Roof': $localize`Roof`,
  'Air Conditioner': $localize`Air Conditioner`,
  'Backhoe': $localize`Backhoe`,
  'Boom Truck': $localize`Boom Truck`,
  'Bulldozer': $localize`Bulldozer`,
  'Crane': $localize`Crane`,
  'Dump Truck': $localize`Dump Truck`,
  'Excavator': $localize`Excavator`,
  'Forklift': $localize`Forklift`,
  'Front Loader': $localize`Front Loader`,
  'Grader': $localize`Grader`,
  'Trencher': $localize`Trencher`,
  'DOT Annual inspection': $localize`DOT Annual inspection`,
  '90 day inspection': $localize`90 day inspection`,
  '180 day inspection': $localize`180 day inspection`,
  'Grease': $localize`Grease`,
  'Filters': $localize`Filters`,
  'License Expiry': $localize`License Expiry`,
};

export const ReportsFaultCodes: II18nBackendStrings = {
  'Open': $localize`Open`,
  'Closed': $localize`Closed`,
  'Constant': $localize`Constant`,
  'Intermittent': $localize`Intermittent`,
  'Intake Air Heater Sys Perf': $localize`Intake Air Heater Sys Perf`,
  'Cylinder 1 Misfire Detected': $localize`Cylinder 1 Misfire Detected`,
  'Evaporative Emission Control System Leak Detected (gross leak)': $localize`Evaporative Emission Control System Leak Detected (gross leak)`,
  'Turbocharger/Supercharger "A" Underboost Condition': $localize`Turbocharger/Supercharger "A" Underboost Condition`,
  'Mass or Volume Air Flow Circuit Low Input': $localize`Mass or Volume Air Flow Circuit Low Input`,
  'Mass or Volume Air Flow Circuit Malfunction': $localize`Mass or Volume Air Flow Circuit Malfunction`,
  'Mass or Volume Air Flow Circuit Range/Performance Problem': $localize`Mass or Volume Air Flow Circuit Range/Performance Problem`,
  'Drive Axle Temperature': $localize`Drive Axle Temperature`,
  'Water In Fuel Indicator 1': $localize`Water In Fuel Indicator 1`,
  'Front Operator Wiper Switch': $localize`Front Operator Wiper Switch`,
  'J1939 Network #1, Primary Vehicle Network': $localize`J1939 Network #1, Primary Vehicle Network`,
  'Total Power Takeoff Hours': $localize`Total Power Takeoff Hours`,
  'Source Address of Controlling Device for Engine Control': $localize`Source Address of Controlling Device for Engine Control`,
  'Ambient Air Temperature': $localize`Ambient Air Temperature`,
  'Engine Total Hours of Operation': $localize`Engine Total Hours of Operation`,
  'SAE J1939 Data Link': $localize`SAE J1939 Data Link`,
  'Left Fuel Level Sensor': $localize`Left Fuel Level Sensor`,
  'Power Supply (obsolete)': $localize`Power Supply (obsolete)`,
  'Engine Intake Manifold 1 Temperature': $localize`Engine Intake Manifold 1 Temperature`,
  'Actual Engine - Percent Torque': $localize`Actual Engine - Percent Torque`,
  'Aftertreatment 1 SCR Intake NOx 1': $localize`Aftertreatment 1 SCR Intake NOx 1`,
  'Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1': $localize`Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1`,
  'Source Address of Controlling Device for Brake Control': $localize`Source Address of Controlling Device for Brake Control`,
  'J1939 Network #2': $localize`J1939 Network #2`,
  'NOx limits exceeded due to Empty Diesel Exhaust Fluid Tank': $localize`NOx limits exceeded due to Empty Diesel Exhaust Fluid Tank`,
  'Engine Exhaust Gas Recirculation 1 Differential Pressure': $localize`Engine Exhaust Gas Recirculation 1 Differential Pressure`,
  'Trip Time in VSL': $localize`Trip Time in VSL`,
  'Engine Cylinder #10 Exhaust Valve Actuator': $localize`Engine Cylinder #10 Exhaust Valve Actuator`,
  'O2 Sensor': $localize`O2 Sensor`,
  'Aftertreatment 1 Diesel Particulate Filter Outlet Pressure': $localize`Aftertreatment 1 Diesel Particulate Filter Outlet Pressure`,
  'Aftertreatment 1 Outlet NOx 1 Reading Stable': $localize`Aftertreatment 1 Outlet NOx 1 Reading Stable`,
  'Forward Rear Drive Axle Temperature': $localize`Forward Rear Drive Axle Temperature`,
  'Vehicle Acceleration': $localize`Vehicle Acceleration`,
  'Transmission Range High Actuator': $localize`Transmission Range High Actuator`,
  'Driver\'s Demand Engine - Percent Torque': $localize`1-Driver\'s Demand Engine - Percent Torque`,
  'Aftertreatment 1 Diesel Particulate Filter Differential Pressure Preliminary FMI': $localize`Aftertreatment 1 Diesel Particulate Filter Differential Pressure Preliminary FMI`,
  'Aftertreatment 1 Outlet NOx 1 Reading Stabl': $localize`Aftertreatment 1 Outlet NOx 1 Reading Stabl`,
  'Forward Rear Drive Axle Temperatur': $localize`Forward Rear Drive Axle Temperatur`,
  'Engine Exhaust Bank 1 Regulator Control Command': $localize`Engine Exhaust Bank 1 Regulator Control Command`,
  'Aftertreatment 1 Diesel Exhaust Fluid Tank Heater': $localize`Aftertreatment 1 Diesel Exhaust Fluid Tank Heater`,
  'Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 State': $localize`Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 State`,
  'Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 1': $localize`Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 1`,
  'Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 State': $localize`Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 State`,
  'Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 State': $localize`Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 State`,
  'Aftertreatment 1 Diesel Exhaust Fluid Controller 1': $localize`Aftertreatment 1 Diesel Exhaust Fluid Controller 1`,
  'Aftertreatment 1 Diesel Exhaust Fluid Tank Volume': $localize`Aftertreatment 1 Diesel Exhaust Fluid Tank Volume`,
  'Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve': $localize`Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve`,
  'Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Absolute Pressure': $localize`Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Absolute Pressure`,
  'Aftertreatment 1 Diesel Exhaust Fluid Doser Valve 1': $localize`Aftertreatment 1 Diesel Exhaust Fluid Doser Valve 1`,
  'Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 1': $localize`Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 1`,
  'Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 State': $localize`Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 State`,
  'Battery Potential / Power Input 1': $localize`Battery Potential / Power Input 1`,
  'Cruise Control Enable Switch': $localize`Cruise Control Enable Switch`,
  'Engine Fuel 1 Injector Cylinder 3': $localize`Engine Fuel 1 Injector Cylinder 3`,
  'Total Engine PTO Governor Fuel Used': $localize`Total Engine PTO Governor Fuel Used`,
  'Engine Starter Mode': $localize`Engine Starter Mode`,
  'Engine Coolant Temperature': $localize`Engine Coolant Temperature`,
  'Engine Coolant Level 1': $localize`Engine Coolant Level 1`,
  'Engine Protection System Timer State': $localize`Engine Protection System Timer State`,
  'Engine Charge Air Cooler 1 Outlet Temperature': $localize`Engine Charge Air Cooler 1 Outlet Temperature`,
  'Tire 12 Leak Status': $localize`Tire 12 Leak Status`,
  'Joystick 5 Button 5 Pressed Status': $localize`Joystick 5 Button 5 Pressed Status`,
  'Particulate Trap Differential Pressure Bank 1': $localize`Particulate Trap Differential Pressure Bank 1`,
  'Aftertreatment 1 Diesel Particulate Filter Differential Pressure': $localize`Aftertreatment 1 Diesel Particulate Filter Differential Pressure`,
  'Engine Air Filter 1 Differential Pressure': $localize`Engine Air Filter 1 Differential Pressure`,
  'Exhaust Gas Recirculation (EGR) Valve #1 Mechanism': $localize`Exhaust Gas Recirculation (EGR) Valve #1 Mechanism`,
  'Engine Exhaust Gas Recirculation 1 Valve 1 Control 1': $localize`Engine Exhaust Gas Recirculation 1 Valve 1 Control 1`,
  'Wheel Sensor ABS Axle 2 Right': $localize`Wheel Sensor ABS Axle 2 Right`,
  'Coolant Level': $localize`Coolant Level`,
  'Recirculated Engine Exhaust Gas Differential Pressure': $localize`Recirculated Engine Exhaust Gas Differential Pressure`,
  'Power Supply': $localize`Power Supply`,
  'ECU Power Output Supply Voltage #1': $localize`ECU Power Output Supply Voltage #1`,
  'Engine Turbocharger 1 Calculated Turbine Intake Temperature': $localize`Engine Turbocharger 1 Calculated Turbine Intake Temperature`,
  'Engine Turbocharger 1 Turbine Inlet Temperature': $localize`Engine Turbocharger 1 Turbine Inlet Temperature`,
  'Key Switch Battery Potential': $localize`Key Switch Battery Potential`,
  'System Diagnostic Code #3': $localize`System Diagnostic Code #3`,
  'Injector Cylinder #1': $localize`Injector Cylinder #1`,
  'Source Address 23': $localize`Source Address 23`,
  'Source Address 40': $localize`Source Address 40`,
  'Injector Cylinder #4': $localize`Injector Cylinder #4`,
  'System Diagnostic Code #2': $localize`System Diagnostic Code #2`,
  'Engine Starter Motor Relay': $localize`Engine Starter Motor Relay`,
  'Wheel Sensor ABS Axle 1 Right': $localize`Wheel Sensor ABS Axle 1 Right`,
  'Source Address 33': $localize`Source Address 33`,
  'Source Address 0': $localize`Source Address 0`,
  'Source Address 3': $localize`Source Address 3`,
  'Wheel Sensor ABS Axle 1 Left': $localize`Wheel Sensor ABS Axle 1 Left`,
  'Engine Fuel 1 Injector Metering Rail 1 Pressure': $localize`Engine Fuel 1 Injector Metering Rail 1 Pressure`,
  'Coolant Thermostat (Coolant Temperature Below Thermostat Regulating Temperature)': $localize`Coolant Thermostat (Coolant Temperature Below Thermostat Regulating Temperature)`,
  'Engine Oil Pressure Sensor/Switch Circuit Range/Performance': $localize`Engine Oil Pressure Sensor/Switch Circuit Range/Performance`,
  'Catalyst System Efficiency Below Threshold (Bank 1)': $localize`Catalyst System Efficiency Below Threshold (Bank 1)`,
  'Cab Controller - Primary': $localize`Cab Controller Primary`,
  'Engine #1': $localize`Engine #1`,
  'Engine #2': $localize`Engine #2`,
  'Brakes - System Controller': $localize`Brakes - System Controller`,
  'Brakes, Power Unit': $localize`Brakes, Power Unit`,
  'Body Controller': $localize`Body Controller`,
  'Cab Display #1': $localize`Cab Display #1`,
  'Transmission #1': $localize`Transmission #1`,
  'Transmission Control System Malfunction': $localize`Transmission Control System Malfunction`,
  'Wheel-Based Vehicle Speed': $localize`Wheel-Based Vehicle Speed`,
  'Diesel Particulate Filter Active Regeneration Inhibited Due to Inhibit Switch': $localize`Diesel Particulate Filter Active Regeneration Inhibited Due to Inhibit Switch`,
  'Exhaust System High Temperature Lamp Command': $localize`Exhaust System High Temperature Lamp Command`,
  'Diesel Particulate Filter Lamp Command': $localize`Diesel Particulate Filter Lamp Command`,
  'Total Vehicle Distance (High Resolution)': $localize`Total Vehicle Distance (High Resolution)`,
  'Engine Instantaneous Fuel Economy': $localize`Engine Instantaneous Fuel Economy`,
  'Accelerator Pedal Position 1': $localize`Accelerator Pedal Position 1`,
  'J1939 Network #3': $localize`J1939 Network #3`,
  'SCR System Cleaning Inhibited Due to Inhibit Switch': $localize`SCR System Cleaning Inhibited Due to Inhibit Switch`,
  'Engine Speed': $localize`Engine Speed`,
  'Source Address 71': $localize`Source Address 71`,
  'PEMS Engine Fuel Mass Flow Rate': $localize`PEMS Engine Fuel Mass Flow Rate`,
  'Transmission Internal Component 2 Speed': $localize`Transmission Internal Component 2 Speed`,
  'Fuel Level 1': $localize`Fuel Level 1`,
  'Engine Cylinder 1 Exclude from Combustion Request': $localize`Engine Cylinder 1 Exclude from Combustion Request`,
  'Exhaust Emission Controller': $localize`Exhaust Emission Controller`,
  'Instrument Cluster 1	': $localize`Instrument Cluster 1	`,
  'O2 Sensor Signal Stuck Rich Bank2 Sensor 1': $localize`O2 Sensor Signal Stuck Rich Bank2 Sensor 1`,
  'Thermostat Heater Control Circuit/Open': $localize`Thermostat Heater Control Circuit/Open`,
  'HO2S Heater Control Circuit (Bank 1 Sensor 2)': $localize`HO2S Heater Control Circuit (Bank 1 Sensor 2)`,
  'A Camshaft Position Actuator Circuit (Bank 1)': $localize`A Camshaft Position Actuator Circuit (Bank 1)`,
  'Engine Oil Pressure': $localize`Engine Oil Pressure`,
  'J1939 Network #4': $localize`J1939 Network #4`,
  'Engine Crankcase Pressure 1': $localize`Engine Crankcase Pressure 1`,
  'Crankcase Pressure': $localize`Crankcase Pressure`,
  'Service Brake Switch Status': $localize`Service Brake Switch Status`,
  'Direction Switch Status': $localize`Direction Switch Status`,
  'Fuel Level Sensor Circuit High Input': $localize`Fuel Level Sensor Circuit High Input`,
  'Evaporative Emissions System Small Leak Detected': $localize`Evaporative Emissions System Small Leak Detected`,
  'Aftertreatment 1 Diesel Particulate Filter Soot Load Percent': $localize`Aftertreatment 1 Diesel Particulate Filter Soot Load Percent`,
  'Wheel Sensor ABS Axle 2 Left': $localize`Wheel Sensor ABS Axle 2 Left`,
  'Transmission Range Attained': $localize`Transmission Range Attained`,
  'Service Odometer': $localize`Service Odometer`,
  'Wheel Sensor, ABS Axle 1 Average': $localize`Wheel Sensor, ABS Axle 1 Average`,
  'Forward Solenoid Valve': $localize`Forward Solenoid Valve`,
  'Trailer Brake Slack Out of Adjustment Forward Axle Left': $localize`Trailer Brake Slack Out of Adjustment Forward Axle Left`,
  'Transmission': $localize`Transmission`,
  'Primary Shift Selector': $localize`Primary Shift Selector`,
  'Wheel Speed Sensor Status': $localize`Wheel Speed Sensor Status`,
  'Retarder Enable Solenoid Valve': $localize`Retarder Enable Solenoid Valve`,
  'Road Speed': $localize`Road Speed`,
  'Battery Potential (Voltage)': $localize`Battery Potential (Voltage)`,
  'Boost Pressure': $localize`Boost Pressure`,
  'Brake Secondary Pressure': $localize`Brake Secondary Pressure`,
  'Retarder Modulation Solenoid Valve': $localize`Retarder Modulation Solenoid Valve`,
  'Mass Air Flow': $localize`Mass Air Flow`,
  'Intake Manifold Temperature': $localize`Intake Manifold Temperature`,
  'Barometric Pressure': $localize`Barometric Pressure`,
  'Parking Brake Switch Status': $localize`Parking Brake Switch Status`,
  'Pressure Modulation Valve ABS Axle 1 Left': $localize`Pressure Modulation Valve ABS Axle 1 Left`,
  'Differential Lock Solenoid Valve': $localize`Differential Lock Solenoid Valve`,
  'Retarder Status': $localize`Retarder Status`,
  'Fuel Level': $localize`Fuel Level`,
  'Hydraulic Pump Motor': $localize`Hydraulic Pump Motor`,
  'Transmission Oil Pressure': $localize`Transmission Oil Pressure`,
  'Engine Oil Burn Valve': $localize`Engine Oil Burn Valve`,
  'Transmission #1 Oil Temperature': $localize`Transmission #1 Oil Temperature`,
  'Clutch Actuator': $localize`Clutch Actuator`,
  'Wheel Sensor ABS Axle 3 Right': $localize`Wheel Sensor ABS Axle 3 Right`,
  'Water in Fuel Indicator': $localize`Water in Fuel Indicator`,
  'Neutral Start Output': $localize`Neutral Start Output`,
  'Retarder Response Solenoid Valve': $localize`Retarder Response Solenoid Valve`,
  'Engine Fuel Valve 1 Intake Absolute Pressure': $localize`Engine Fuel Valve 1 Intake Absolute Pressure`,
  'Retarder Control Relay': $localize`Retarder Control Relay`,
  'Engine Fuel 1 Injector Cylinder 6': $localize`Engine Fuel 1 Injector Cylinder 6`,
  'O2 Sensor Signal Stuck Rich Bank1 Sensor 1': $localize`O2 Sensor Signal Stuck Rich Bank1 Sensor 1`,
  'Transmission Primary Shift Selector': $localize`Transmission Primary Shift Selector`,
  'Engine Total Idle Hours': $localize`Engine Total Idle Hours`,
  'Brake Primary Pressure': $localize`Brake Primary Pressure`,
  'Hydraulic Retarder Oil Temperature': $localize`Hydraulic Retarder Oil Temperature`,
  'Engine Retarder Switches Status': $localize`Engine Retarder Switches Status`,
  'Engine Misfire Cylinder #6': $localize`Engine Misfire Cylinder #6`,
  'Engine Misfire for Multiple Cylinders': $localize`Engine Misfire for Multiple Cylinders`,
  'Engine Intake Air Mass Flow Rate': $localize`Engine Intake Air Mass Flow Rate`,
  'Engine Fuel Actuator 1 Control Command': $localize`Engine Fuel Actuator 1 Control Command`,
  'Tire Pressure': $localize`Tire Pressure`,
  'Tire Location': $localize`Tire Location`,
  'Engine Retarder Selection': $localize`Engine Retarder Selection`,
  'VDC Fully Operational': $localize`VDC Fully Operational`,
  'Source Address 11': $localize`Source Address 11`,
  'Aftertreatment Diesel Exhaust Fluid Tank Low Level Indicator': $localize`Aftertreatment Diesel Exhaust Fluid Tank Low Level Indicator`,
  'Aftertreatment SCR Operator Inducement Severity': $localize`Aftertreatment SCR Operator Inducement Severity`,
  'Engine Fuel Delivery Pressure': $localize`Engine Fuel Delivery Pressure`,
  'Front Operator Washer Switch': $localize`Front Operator Washer Switch`,
};

export const ReportsCategories: II18nBackendStrings = {
  'Logs': $localize`Logs`,
  'Compliance': $localize`Compliance`,
  'Fuel': $localize`Fuel`,
  'IFTA': $localize`IFTA`,
  'Cards': $localize`Cards`,
  'Trips': $localize`Trips`,
  'Assets': $localize`Assets`,
  'Drivers': $localize`Drivers`,
  'Vehicles': $localize`Vehicles`,
  'Geofences': $localize`Geofences`,
  'Dispatches': $localize`Dispatches`,
  'Maintenance': $localize`Maintenance`,
  'Utilization': $localize`Utilization`,
  'Inspection Reports': $localize`Inspection Reports`,
  'Safety': $localize`Safety`,
  'Security': $localize`Security`,
  'Timecards': $localize`Timecards`,
  'Documents': $localize`Documents`,
  'Devices': $localize`Devices`,
};

export const ReportsData: II18nReportsData = {
  'completed-dispatches': {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Trends and reports for planned, active, completed and canceled dispatches`,
    title: $localize`Completed Dispatch`,
  },
  'cancelled-dispatches': {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Trends and reports for planned, active, completed and canceled dispatches`,
    title: $localize`Cancelled Dispatch`,
  },
  'bendix-status': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Bendix connection status for all vehicles`,
    title: $localize`Bendix Connection Status`,
  },
  [REPORT_KEYS.DISPATCH_SUMMARY]: {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Trends and reports for planned, active, completed and canceled dispatches`,
    title: $localize`Dispatch Summary`,
  },
  [REPORT_KEYS.ACTIVE_DISPATCHES]: {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Summary of all active dispatches`,
    title: $localize`Active Dispatches`,
  },
  'trips-activity-detail': {
    categoryName: ReportsCategories['Trips'],
    description: $localize`Detailed activity by driver, vehicle or asset`,
    title: $localize`Activity Detail`,
  },
  'assets': {
    categoryName: ReportsCategories['Assets'],
    description: $localize`Summary of daily and lifetime engine hours by asset`,
    title: $localize`Asset Engine Hours`,
  },
  'assets-detail': {
    categoryName: ReportsCategories['Assets'],
    description: $localize`Details of all assets`,
    title: $localize`Assets Detail`,
  },
  'assets-utilization-summary': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Summary of usage by asset`,
    title: $localize`Asset Utilization`,
  },
  'dashcam-connection': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Details of all camera connection and disconnects events`,
    title: $localize`Dashcam Connection History`,
  },
  'vehicle-data-usage-summary': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Summary of data usage in current cycle by vehicle`,
    title: $localize`Wifi Usage Summary`,
  },
  'disconnects': {
    categoryName: ReportsCategories['Trips'],
    description: $localize`Detail of all disconnects by vehicle or group`,
    title: $localize`Disconnects Detail`,
  },
  'ifta-distance': {
    categoryName: ReportsCategories['IFTA'],
    description: $localize`Summary of distance traveled in each jurisdiction by vehicle and fleet`,
    title: $localize`Distance Summary`,
  },
  'ifta-distance-rearch': {
    categoryName: ReportsCategories['IFTA'],
    description: $localize`Summary of distance traveled in each jurisdiction by vehicle and fleet`,
    title: $localize`Distance Summary`,
  },
  'dormant': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Details of assets and vehicles that are currently dormant`,
    title: $localize`Dormancy`,
  },
  'driver-utilization-summary': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Summary of all idling time and driving time by driver`,
    title: $localize`Driver\'s Vehicle Utilization`,
  },
  'drivers': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Details of all drivers`,
    title: $localize`Drivers Detail`,
  },
  'spend-summary-by': {
    categoryName: ReportsCategories['Cards'],
    description: $localize`A detailed summary of spend by vehicle, cardholder, category or card`,
    title: $localize`Spend Summary Detail`,
  },
  'transactions': {
    categoryName: ReportsCategories['Cards'],
    description: $localize`A detailed report for all your Motive Card transactions`,
    title: $localize`Transaction Details`,
  },
  'category-adjustable-transactions': {
    categoryName: ReportsCategories['Cards'],
    description: $localize`Transactions categorized as “misc.” that are likely “fuel”`,
    title: $localize`Potential Fuel Transactions`,
  },
  'drivers-workload': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`List of all drivers with drive time and distance driven`,
    title: $localize`Drivers Workload`,
  },
  'driver-walkthrough': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`List of all driver walkthroughs`,
    title: $localize`Walkthrough Summary`,
  },
  'vehicle-diagnostics': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Lists fault codes by vehicle or group`,
    title: $localize`Fault Codes`,
  },
  'form-manner': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Breakdown of Form & Manner errors by driver or group`,
    title: $localize`Form & Manner Errors Detail`,
  },
  'ifta-fuel': {
    categoryName: ReportsCategories['IFTA'],
    description: $localize`Detail of fuel purchases by vehicle, driver or group`,
    title: $localize`Fuel Purchase Details`,
  },
  'geofence-inventory': {
    categoryName: ReportsCategories['Geofences'],
    description: $localize`Details of all vehicles and assets in geofences`,
    title: $localize`Geofence Inventory`,
  },
  'geofence-summary': {
    categoryName: ReportsCategories['Geofences'],
    description: $localize`Summary of all events by geofence, vehicle or asset`,
    title: $localize`Geofence Summary`,
  },
  'hos-violations': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Breakdown of HOS Violations by driver or group`,
    title: $localize`HOS Violations Detail`,
  },
  'ifta-trips': {
    categoryName: ReportsCategories['IFTA'],
    description: $localize`Detail of all IFTA trips by vehicle or group`,
    title: $localize`IFTA Trips`,
  },
  'ifta-trips-rearch': {
    categoryName: ReportsCategories['IFTA'],
    description: $localize`Detail of all IFTA trips by vehicle or group`,
    title: $localize`IFTA Trips`,
  },
  'idling-event-detail': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Details of all idling events by day`,
    title: $localize`Idling Events`,
  },
  'vehicle-inspection-detail': {
    categoryName: ReportsCategories['Inspection Reports'],
    description: $localize`Detail of all Inspection Reports by day`,
    title: $localize`Inspection Reports Detail`,
  },
  'location-history': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Breakdown of breadcrumb location history for each vehicle`,
    title: $localize`Location History`,
  },
  'log-audit': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`An audit trail for all duty status changes`,
    title: $localize`Log Audit Detail`,
  },
  'log-edits': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Detail of all log edits`,
    title: $localize`Log Edits`,
  },
  'logs-detail': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Detail of all logs data by day`,
    title: $localize`Logs Detail`,
  },
  'logs-without-inspection-reports': {
    categoryName: ReportsCategories['Inspection Reports'],
    description: $localize`Breakdown of all logs with driving hours but no Inspection Reports`,
    title: $localize`Logs without Vehicle Inspection Reports`,
  },
  'maintenance-history-detail': {
    categoryName: ReportsCategories['Maintenance'],
    description: $localize`Detail of all maintenance service notes`,
    title: $localize`Maintenance History Detail`,
  },
  'maintenance-reminder-detail': {
    categoryName: $localize`Maintenance`,
    description: $localize`Detail of all maintenance reminders by status`,
    title: $localize`Maintenance Reminders Detail`,
  },
  'availability-report':{
    categoryName: ReportsCategories['Maintenance'],
    description: $localize`Detail of Availability for vehicle or assets`,
    title: $localize`Vehicle & Asset Availability`,
  },
  'requested-videos': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Details of all requested videos from Smart Dashcam`,
    title: $localize`Requested Videos`,
  },
  'safety-events': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Detail of all safety events by driver`,
    title: $localize`Safety Events`,
  },
  'safety-summary': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of all driver Safety Scores`,
    title: $localize`Safety Summary`,
  },
  'speeding-events': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Detail of all speeding events by driver`,
    title: $localize`Speeding Events`,
  },
  'speeding-over-policy-events': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Detail of all speeding over policy events by driver`,
    title: $localize`Speeding Over Policy Events`,
  },
  'tire-pressure-events': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Details of all tire pressure events from TPMS sensors`,
    title: $localize`Tire Pressure Events`,
  },
  'trips': {
    categoryName: ReportsCategories['Trips'],
    description: $localize`Detail of all trips by vehicle, driver or group`,
    title: $localize`Trips Detail`,
  },
  'trips-summary': {
    categoryName: ReportsCategories['Trips'],
    description: $localize`Summary of all trips by vehicle or group`,
    title: $localize`Trips Summary`,
  },
  'vehicle-gateways': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`List of all Vehicle Gateways and currently assigned vehicles`,
    title: $localize`Vehicle Gateways Detail`,
  },
  'vehicle-utilization-summary': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Summary of all idling time and driving time by vehicle`,
    title: $localize`Vehicle Utilization`,
  },
  'vehicles': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Details of all vehicles`,
    title: $localize`Vehicles Detail`,
  },
  'violation-and-error-summary': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Count of HOS violations and Form & Manner errors by type`,
    title: $localize`Violation & Error Summary`,
  },
  'driver-fuel-performance': {
    categoryName: ReportsCategories['Fuel'],
    description: $localize`Fuel performance report of all drivers`,
    title: $localize`Driver Fuel Performance`,
  },
  'vehicle-fuel-performance': {
    categoryName: ReportsCategories['Fuel'],
    description: $localize`Fuel performance report of all vehicles`,
    title: $localize`Vehicle Fuel Performance`,
  },
  'aux-activity-detail': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Detailed AUX activity events by vehicle`,
    title: $localize`AUX Activity Detail`,
  },
  'coaching-effectiveness-tab': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of Coaching Impact on driver safety performance`,
    title: $localize`Driver Coaching Effectiveness`,
  },
  'FMCT': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of Fleet Manager Coaching Activity`,
    title: $localize`Fleet Manager Coaching Effectiveness`,
  },
  'fct2022': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of the percentage of Coachable drivers by month`,
    title: $localize`Monthly Driver Coaching Trend`,
  },
  'wm-event-detail-report	': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of driver safety performance`,
    title: $localize`wm-event-detail-report`,
  },
  'jle-pend-disp': {
    categoryName: ReportsCategories['Dispatches'],
    description: '',
    title: $localize`Pending Dispatches Report`,
  },
  'dispatch_demo': {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Trends and reports for planned, active, completed and canceled dispatches`,
    title: $localize`Dispatch Summary Demo`,
  },
  'QA_Embed1': {
    categoryName: ReportsCategories['Dispatches'],
    description: $localize`Testing out Tableau report `,
    title: $localize`QA Embedded 1`,
  },
  'acre': {
    categoryName: ReportsCategories['Trips'],
    description: $localize`Acre Detail`,
    title: $localize`Acre Detail`,
  },
  'reefer-activity': {
    categoryName: ReportsCategories['Assets'],
    description: $localize`Detailed reefer activity and temperatures`,
    title: $localize`Reefer Activity`,
  },
  'vehicle-util-custom': {
    categoryName: ReportsCategories['Utilization'],
    description: $localize`Vehicle utilization on a month level calculated through a custom definition of driving hours / 8, as requested by the customer`,
    title: $localize`Vehicle Utilization (Custom)`,
  },
  'fleet_users_detail': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`details of fleet users`,
    title: $localize`Fleet Users Detail`,
  },
  'hos-recap': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Report of HOS recaps for drivers`,
    title: $localize`HOS Recap`,
  },
  'log-dynamic': {
    categoryName: ReportsCategories['Logs'],
    description: $localize`Testing Dynamic Report`,
    title: $localize`Log Dynamic`,
  },
  'hcc-osha': {
    categoryName: ReportsCategories['Logs'],
    description: '',
    title: $localize`hcc reports`,
  },
  'Consolidated Wellsite - False Miles Accumulated': {
    categoryName: ReportsCategories['IFTA'],
    description: '',
    title: $localize`False Miles Accumulated`,
  },
  'geofence-speeding-violation': {
    categoryName: ReportsCategories['Geofences'],
    description: $localize`Report of all speeding violations in a geofence`,
    title: $localize`Geofence Speeding Violations`,
  },
  'kpc-payroll': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Custom Payroll Report`,
  },
  'Aifleet - Custom Speeding Report': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Custom Speeding Report`,
  },
  [REPORT_KEYS.CAMERA_DETAIL]: {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`List of all cameras and their statuses`,
    title: $localize`Cameras Detail`,
  },
  [REPORT_KEYS.CAMERA_DETAIL_V2]: {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`List of all cameras and their statuses`,
    title: $localize`Cameras Detail`,
  },
  'R&J_FaultIdentificationReport': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`R&J_FaultIdentificationReport`,
    title: $localize`R&J_FaultIdentificationReport`,
  },
  'Trans - Phos - Car Status Report': {
    categoryName: ReportsCategories['Vehicles'],
    description: $localize`Trans - Phos - Car Status Report`,
    title: $localize`Trans - Phos - Car Status Report`,
  },
  'shipex_speeding': {
    categoryName: ReportsCategories['Maintenance'],
    description: $localize`Shipex speeding heatmap`,
    title: $localize`Shipex Speeding`,
  },
  'hcc-osha-2': {
    categoryName: ReportsCategories['Maintenance'],
    description: '',
    title: $localize`hcc reports 2`,
  },
  'coaching-effectiveness': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of Coaching Impact on Driver Safety Performance (Native)`,
    title: $localize`Driver Coaching Effectiveness`,
  },
  'Lily Transport - Drivers Last Status': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Driver Last Status`,
    title: $localize`Driver Last Status`,
  },
  'safety-behavior-summary': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of Safety Behaviors for each Driver`,
    title: $localize`Driver Safety Performance Report`,
  },
  'wm-event-detail-report': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Summary of driver safety performance`,
    title: $localize`Event Detail Report`,
  },
  'shipex-pc-rpt': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Personal Conveyance Report`,
  },
  'Rosending Coaching Report': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Rosending Coaching Report`,
    title: $localize`Rosending Coaching Report`,
  },
  'sw-mgt-safety-report-summary': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Safety - Custom Summary Report`,
  },
  'sw-mgt-safety-report-event-distribution': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Safety events distributed over a Pie chart.`,
    title: $localize`Safety - Event Distribution`,
  },
  'w-mgt-safety-report-miles-without-incident': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Safety - Miles Without Incident`,
  },
  'sw-mgt-safety-report-top-drivers': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Top drivers with miles without incident.`,
    title: $localize`Safety - Top Drivers`,
  },
  'sw-mgt-safety-report': {
    categoryName: ReportsCategories['Drivers'],
    description: '',
    title: $localize`Safety Summary Report - Compiled`,
  },
  'TSS Group - Driver Audit Report 2': {
    categoryName: ReportsCategories['Drivers'],
    description: $localize`Driver Audit Report 2`,
    title: $localize`TSS Group - Driver Audit Report 2`,
  },
  'fleet-coaching-trend': {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Coaching engagement among the fleet`,
    title: $localize`Fleet Coaching Trend`,
  },
  'dismissed-events': {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Dismissed safety events`,
    title: $localize`Dismissed Events`,
  },
  'compliance-coaching': {
    categoryName: ReportsCategories['Compliance'],
    description: $localize`Summary of compliance coaching`,
    title: $localize`Compliance Coaching`,
  },
  'enhanced-compliance-coaching': {
    categoryName: ReportsCategories['Compliance'],
    description: $localize`Enhanced summary of compliance coaching`,
    title: $localize`Enhanced Compliance Coaching`,
  },
  'speeding-disputes': {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Summary of Speeding Disputes raised over a time range`,
    title: $localize`Speeding Disputes`,
  },
  [REPORT_KEYS.DOOR_OPEN_EVENTS]: {
    categoryName: ReportsCategories['Security'],
    description: $localize`Detailed door sensor activity for vehicles`,
    title: $localize`Door Sensor Events`,
  },
  [REPORT_KEYS.COACH_PERFORMANCE]: {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Summary of coaching performance`,
    title: $localize`Safety Coach Performance`,
  },
  [REPORT_KEYS.GROUP_SCORE]: {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Analyze Group Safety Score performance over time`,
    title: $localize`Group Safety Score`,
  },
  [REPORT_KEYS.FLEET_SCORE]: {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Analyze Fleet Safety Score performance over time`,
    title: $localize`Fleet Safety Score`,
  },
  [REPORT_KEYS.DRIVER_SCORE]: {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Analyze Driver Safety Score performance over time`,
    title: $localize`Driver Safety Score`,
  },
  'timecard-details': {
    categoryName: ReportsCategories['Timecards'],
    description: $localize`View the detail of Driver’s Timecard entries`,
    title: $localize`Timecard Details`,
  },
  'timecard-summary': {
    categoryName: ReportsCategories['Timecards'],
    description: $localize`View a summary of Driver’s Hours Worked Data for Logs and Timecards`,
    title: $localize`Hours Worked`,
  },
  [REPORT_KEYS.ASSET_GATEWAY_DETAIL]: {
    title: $localize`Asset Devices Detail`,
    description: $localize`List of all Asset Gateways, currently assigned to assets`,
    categoryName: ReportsCategories['Assets'],
  },
  'eld-output-files': {
    title: $localize`ELD Output File`,
    description: $localize`Details of all the ELD output files`,
    categoryName: ReportsCategories.Compliance,
  },
  'compliance-driving-events': {
    categoryName: ReportsCategories['Compliance'],
    description: $localize`Detail of all driving events by vehicle, driver or group`,
    title: $localize`Driving Events Detail`,
  },
  'compliance-driving-events-summary': {
    categoryName: ReportsCategories['Compliance'],
    description: $localize`Summary of all driving events by vehicle or group`,
    title: $localize`Driving Events Summary`,
  },
  [REPORT_KEYS.EV_ENERGY_USAGE]: {
    title: $localize`EV Energy Usage`,
    description: $localize`Summary of energy usage for all EV and PHEV vehicles`,
    categoryName: ReportsCategories['Fuel'],
  },
  [REPORT_KEYS.INCAB_ALERTS]: {
    title: $localize`Safety In-cab Alerts`,
    description: $localize`Analyze driver in-cab alerts by safety behavior`,
    categoryName: ReportsCategories['Safety'],
  },
  [REPORT_KEYS.DRIVER_QUALIFICATION_DOCUMENTS]: {
    title: $localize`Driver Qualification Documents Report`,
    description: $localize`A report for all the Driver Qualification Documents`,
    categoryName: ReportsCategories['Documents'],
  },
  [REPORT_KEYS.VEHICLE_DOCUMENTS]: {
    title: $localize`Vehicle Documents Report`,
    description: $localize`A report for all the Vehicle Documents`,
    categoryName: ReportsCategories['Documents'],
  },
  'devices-report': {
    categoryName: ReportsCategories['Devices'],
    description: $localize`Device status of vehicle gateways and dashcams`,
    title: $localize`Device Status Report`,
  },
  [REPORT_KEYS.CARB_CLEAN_TRUCK_CHECK]: {
    categoryName: ReportsCategories['Maintenance'],
    description: $localize`Detail of CARB Clean Truck Check submissions`,
    title: $localize`CARB Clean Truck Check`,
  },
  [REPORT_KEYS.SAFETY_SCORE_POINTS_TABLE_V2]: {
    categoryName: ReportsCategories['Safety'],
    description: $localize`Safety Scores Points table report`,
    title: $localize`Safety Scores - Points Table`,
  },
};

export const TimeZones: II18nBackendStrings = {
  'Eastern Time (US & Canada)': $localize`Eastern Time (US & Canada)`,
  'Indiana (East)': $localize`Indiana (East)`,
  'Central Time (US & Canada)': $localize`Central Time (US & Canada)`,
  'Saskatchewan': $localize`Saskatchewan`,
  'Mountain Time (US & Canada)': $localize`Mountain Time (US & Canada)`,
  'Arizona': $localize`Arizona`,
  'Pacific Time (US & Canada)': $localize`Pacific Time (US & Canada)`,
  'Alaska': $localize`Alaska`,
  'Atlantic Time (Canada)': $localize`Atlantic Time (Canada)`,
  'Hawaii': $localize`Hawaii`,
  'Newfoundland': $localize`Newfoundland`,
};

export const Admin: II18nBackendStrings = {
  'Drivers and Fleet Managers': $localize`Drivers and Fleet Managers`,
  'Vehicles': $localize`Vehicles`,
  'Messages': $localize`Messages`,
  'Fuel Purchases': $localize`Fuel Purchases`,
  'Groups': $localize`Groups`,
  'ELDs': $localize`ELDs`,
  'Inspection Reports': $localize`Inspection Reports`,
  'Fault Codes': $localize`Fault Codes`,
  'Drivers with Available Time': $localize`Drivers with Available Time`,
  'Drivers with Hours of Service': $localize`Drivers with Hours of Service`,
  'HOS Violations': $localize`HOS Violations`,
  'HOS Logs': $localize`HOS Logs`,
  'Drivers with Current Location and Current Vehicle': $localize`Drivers with Current Location and Current Vehicle`,
  'IFTA Trips': $localize`IFTA Trips`,
  'Vehicles\' Mileage Summary': $localize`Vehicles Mileage Summary`,
  'Utilization Summary by Driver': $localize`Utilization Summary by Driver`,
  'Utilization Summary by Vehicle': $localize`Utilization Summary by Vehicle`,
  'Utilization Records': $localize`Utilization Records`,
  'Documents': $localize`Documents`,
  'Company Details': $localize`Company Details`,
  'Dispatch Forms': $localize`Dispatch Forms`,
  'Dispatch Form Entries': $localize`Dispatch Form Entries`,
  'Dispatch Locations': $localize`Dispatch Locations`,
  'Dispatches': $localize`Dispatches`,
  'Geofences': $localize`Geofences`,
  'Geofence Events': $localize`Geofence Events`,
  'Assets': $localize`Assets`,
  'Asset Gateway': $localize`Asset Gateway`,
  'Asset with Asset Gateway Location History': $localize`Asset with Asset Gateway Location History`,
  'Trips': $localize`Trips`,
  'Dispatch Offerings': $localize`Dispatch Offerings`,
  'Dispatch Offering Loads': $localize`Dispatch Offering Loads`,
  'Freight Visibility': $localize`Freight Visibility`,
  'View': $localize`View`,
  'view': $localize`View`,
  'Manage': $localize`Manage`,
  'manage': $localize`Manage`,
  'Agriculture': $localize`Agriculture`,
  'Construction': $localize`Construction`,
  'Field Services': $localize`Field Services`,
  'Food & Beverage': $localize`Food & Beverage`,
  'For-Hire Trucking': $localize`For-Hire Trucking`,
  'Manufacturing': $localize`Manufacturing`,
  'Moving & Storage': $localize`Moving & Storage`,
  'Oil & Gas': $localize`Oil & Gas`,
  'Passenger Transport': $localize`Passenger Transport`,
  'Other': $localize`Other`,
  'deactivated': $localize`Deactivated`,
  'active': $localize`Active`,
  'pending': $localize`Pending`,
  'all': $localize`All`,
  'vehicle': $localize`Vehicle`,
  'asset': $localize`Asset`,
};

export const Documents: II18nBackendStrings = {
  'accident photo': $localize`Accident Photo`,
  'scale ticket': $localize`Scale Ticket`,
  'bill of lading': $localize`Bill of Lading`,
  'other': $localize`Other`,
  'fuel receipt': $localize`Fuel Receipt`,
  'citation': $localize`Citation`,
};

export const Messages: II18nBackendStrings = {
  'joined.': $localize`joined.`,
  'left.': $localize`left.`,
};

export const SingularPluralsMap: II18nSingularPlural = {
  'minute': { singular: $localize`minute`, plural: $localize`minutes` },
  'hour': { singular: $localize`hour`, plural: $localize`hours` },
  'day': { singular: $localize`day`, plural: $localize`days` },
  'week': { singular: $localize`week`, plural: $localize`weeks` },
  'wk': { singular: $localize`wk`, plural: $localize`wk` },
  'month': { singular: $localize`month`, plural: $localize`months` },
  'year': { singular: $localize`year`, plural: $localize`years` },
  'yr': { singular: $localize`yr`, plural: $localize`yrs` },
  'mo': { singular: $localize`mo`, plural: $localize`mo` },
  'hr': { singular: $localize`hr`, plural: $localize`hrs` },
  'min': { singular: $localize`min`, plural: $localize`mins` },
  'sec': { singular: $localize`sec`, plural: $localize`secs` },
  'second': { singular: $localize`second`, plural: $localize`seconds` },
  'millisecond': { singular: $localize`millisecond`, plural: $localize`milliseconds` },
  'miles': { singular: $localize`mile`, plural: $localize`miles` },
  'engine hours': { singular: $localize`engine hour`, plural: $localize`engine hours` },
  'w': { singular: $localize`w`, plural: $localize`w` },
  'd': { singular: $localize`d`, plural: $localize`d` },
  'h': { singular: $localize`h`, plural: $localize`m` },
  'm': { singular: $localize`m`, plural: $localize`h` },
  's': { singular: $localize`s`, plural: $localize`s` },
  'ms': { singular: $localize`ms`, plural: $localize`ms` },
  'asset': { singular: $localize`asset`, plural: $localize`assets` },
  'driver': { singular: $localize`driver`, plural: $localize`drivers` },
  'vehicle': { singular: $localize`vehicle`, plural: $localize`vehicles` },
  'document': { singular: $localize`document`, plural: $localize`documents` },
  'location': { singular: $localize`location`, plural: $localize`locations` },
  'user': { singular: $localize`user`, plural: $localize`users` },
  'card': { singular: $localize`card`, plural: $localize`cards` },
  'SUN': { singular: $localize`Sunday`, plural: $localize`Sundays` },
  'MON': { singular: $localize`Monday`, plural: $localize`Mondays` },
  'TUE': { singular: $localize`Tuesday`, plural: $localize`Tuesdays` },
  'WED': { singular: $localize`Wednesday`, plural: $localize`Wednesdays` },
  'THU': { singular: $localize`Thursday`, plural: $localize`Thursdays` },
  'FRI': { singular: $localize`Friday`, plural: $localize`Fridays` },
  'SAT': { singular: $localize`Saturday`, plural: $localize`Saturdays` },
  'defect': { singular: $localize`defect`, plural: $localize`defects` },
};

export const CardholdersCardStatus = {
  all: $localize`All`,
  active: $localize`Active`,
  active_locked: $localize`Locked`,
  active_unlocked: $localize`Active`,
  inactive: $localize`Inactive`,
  frozen: $localize`Frozen`,
  suspended: $localize`Suspended`,
  unactivated: $localize`Unactivated`,
  assigned: $localize`Assigned`,
  unassigned: $localize`Unassigned`,
};

export const FleetCardsTransactionStatuses = {
  completed: $localize`Pending`,
  reversed: $localize`Reversed`,
  pending: $localize`Pending`,
  refund_pending: $localize`Pending`,
  refund_reversed: $localize`Reversed`,
  refund_declined: $localize`Declined`,
  declined: $localize`Declined`,
  credit: $localize`Credit`,
  disputed: $localize`Disputed`,
  disputeOpen: $localize`Dispute: open`,
  disputeClosed: $localize`Dispute: closed`,
  disputeOpened: $localize`Dispute: open`,
  posted: $localize`Posted`,
  error: $localize`Error`,
  refund: $localize`Refunded`,
};

export const FleetCardsTransactionDateTypes = {
  purchase_date: $localize`Purchase date (MDY)`,
  posted_date: $localize`Posted date (MDY)`,
};

export const FleetCardsInternalCreditStatuses = {
  completed: $localize`Posted`,
  reversed: $localize`Reversed`,
};

export const FleetCardsInternalDebitStatuses = {
  completed: $localize`Posted`,
  reversed: $localize`Reversed`,
};

export const FleetCardsFeeStatuses = {
  completed: $localize`Posted`,
  reversed: $localize`Reversed`,
};

export const DispatchSummaryReportLabels: II18nBackendStrings = Object.freeze({
  delivery: $localize`delivery`,
  pickup: $localize`pickup`,
  deliveryUppercase: $localize`DELIVERY`,
  pickupUppercase: $localize`PICKUP`,
  onTime: $localize`On Time`,
  delayed: $localize`Delayed`,
  previous7Days: $localize`vs. Previous 7 Days`,
  previous30Days: $localize`vs. Previous 30 Days`,
  previous90Days: $localize`vs. Previous 90 Days`,
  previous1Year: $localize`vs. Previous 1 Year`,
  totalPlannedDescription: $localize`of total planned dispatches were completed.`,
  totalAcceptedDescription: $localize`of total planned dispatches were accepted.`,
  totalCompletedDescription: $localize`of accepted dispatches were completed.`,
  stopLabel: $localize`stop`,
  stopsLabel: $localize`stops`,
  completedDispatchDelayedLabel: $localize` delayed`,
  dispatchSummaryArrivedText: $localize`Arrived at destination on`,
  dispatchSummaryCancelledOnText: $localize`Canceled on`,
  byText: $localize`by`,
  todayBetweenText: $localize`today between`,
  betweenText: $localize`between`,
  onText: $localize`on`,
  lateLabel: $localize` late`,
  AcceptedText: $localize`Accepted`,
  notAcceptedText: $localize`Not Accepted`,
  stops: $localize`stops`,
  stop: $localize`stop`,
});

export const FleetCards: II18nBackendStrings = Object.freeze({
  fleetCardsTitle: $localize`Cards`,
  applyForCardsTitle: $localize`Apply for Card`,
  fleetCardsApplicationTitle: $localize`Cards application`,
  billingTabTitle: $localize`Billing`,
  cardManagementTabTitle: $localize`Card Management`,
  ordersTabTitle: $localize`Orders`,
  settingsTabTitle: $localize`Configuration`,
  settingsV2TabTitle: $localize`Settings`,
  policiesTabTitle: $localize`Policies`,
  accountOverviewHeaderTitle: $localize`Account Overview`,
  overviewHeaderTitle: $localize`Overview`,
  changeDefaultAccountTitle: $localize`Payment methods`,
  benefitsTitle: $localize`Benefits`,
  accountOverviewPendingTransactions: $localize`Pending Transactions`,
  accountOverviewCurrentBalance: $localize`Current Balance`,
  accountOverviewRemainingCredit: $localize`Available Credit`,
  accountOverviewPaymentsInProcess: $localize`Processing Payments`,
  accountOverviewPendingTransactionsPopoverV2: $localize`Includes transactions that have not yet been posted, which impacts your available credit.`,
  accountOverviewCurrentBalancePopoverV2: $localize`The amount of money you currently owe on your account. Includes posted transactions and excludes processing payments.`,
  accountOverviewRemainingCreditPopoverV2: $localize`The amount of money you have left to use in a billing cycle. Available credit is updated when a payment is processed or an adjustment is made on a previous invoice.`,
  accountOverviewPaymentsInProcessPopover: $localize`Includes payments that are in progress but not complete.`,
  lockedText: $localize`Locked`,
  noInvoicesMessage: $localize`No invoices have been posted yet.`,
  noPaymentsMessage: $localize`No payments have been made yet.`,
  lockedBannerAdminText: $localize`Pay the full amount due to regain access to your cards.`,
  canceledBannerAdminText: $localize`Please reach out to support to re-instate your account.`,
  canceledBannerNonAdminText: $localize`Contact your fleet admin to resolve the issue.`,
  lockedBannerPaymentInProgressText: $localize`Your payment is in progress. Once your outstanding balance is cleared you will automatically regain access to your credit.`,
  lockedBannerNonAdminText: $localize`All cards are currently unavailable. Contact your fleet admin to resolve the issue.`,
  reauthLockedBannerAdminText: $localize`You need to authenticate your primary bank account.`,
  reauthLockedBannerNonAdminText: $localize`You need to authenticate your primary bank account. Contact your fleet admin to resolve the issue.`,
  reauthWarnBannerAdminText: $localize`Please re-authenticate your bank account to have uninterrupted access to Motive Cards.`,
  reauthWarnBannerAdminLinkText: $localize`Please reauthenticate your bank account to get quicker access to your funds.`,
  reauthWarnBannerNonAdminText: $localize`Please re-authenticate your bank account to have uninterrupted access to Motive Cards. Contact your fleet admin to resolve the issue.`,
  contactSupportText: $localize`Please contact support to resolve the issue.`,
});

export const FleetCardsTransactionDeclineReasons: II18nBackendStrings = Object.freeze({
  invalid_funding_method: $localize`transaction not allowed.`,
  unsupported_funding_method: $localize`transaction not allowed.`,
  risk_profile_restrictions_mcc_blocked: $localize`restricted item.`,
  risk_profile_restrictions_online_mid_blocked: $localize`card restricted at merchant.`,
  invalid_company_deactivated: $localize`account canceled.`,
  invalid_company_credit_frozen: $localize`account suspended.`,
  invalid_company_account_locked: $localize`account suspended.`,
  invalid_user: $localize`card is deactivated.`,
  invalid_card_state_suspended: $localize`card is frozen.`,
  invalid_card_state_unactivated: $localize`card is not activated.`,
  invalid_card_state_terminated: $localize`card is deactivated.`,
  invalid_card_state_unassigned: $localize`card is unassigned`,
  no_default_payment_method: $localize`no linked bank account.`,
  user_maximum_transaction_amount_exceeded: $localize`transaction limit reached.`,
  declined_by_marqeta_1841: $localize`per transaction limit reached.`,
  user_billing_cycle_credit_exceeded: $localize`cardholder credit limit reached.`,
  declined_by_marqeta_1834: $localize`spend limit reached.`,
  day_limit_exceeded: $localize`day spend limit reached.`,
  week_limit_exceeded: $localize`weekly spend limit reached.`,
  month_limit_exceeded: $localize`monthly spend limit reached.`,
  company_credit_exceeded: $localize`company spend limit reached.`,
  user_transaction_day_restricted: $localize`transaction attempted on a restricted day.`,
  user_transaction_time_restricted: $localize`transaction attempted during restricted time period.`,
  declined_by_marqeta_1003: $localize`card is suspended.`,
  declined_by_marqeta_1016: $localize`unexpected problem occurred.`,
  declined_by_marqeta_1880: $localize`unexpected problem occurred.`,
  time_out: $localize`unexpected problem occurred.`,
  declined_by_marqeta_1806: $localize`card is not activated.`,
  declined_by_marqeta_1809: $localize`incorrect PIN.`,
  declined_by_marqeta_1813: $localize`card is deactivated.`,
  declined_by_marqeta_1825: $localize`issue reading magnetic strip.`,
  declined_by_marqeta_1826: $localize`incorrect billing zip code.`,
  avs_failed: $localize`incorrect billing zip code.`,
  avs_failed_card_frozen: $localize`invalid billing zip code. Card frozen.`,
  declined_by_marqeta_1915: $localize`invalid security code.`,
  declined_by_marqeta_1915_card_frozen: $localize`invalid security code. Card frozen.`,
  declined_by_marqeta_1825_custom: $localize`card reader issue.`,
  declined_by_marqeta_1825_custom_msg: $localize`card reader issue at Love's. Cardholders can enter their Motive Card at the pump to complete their purchase.`,
  declined_by_marqeta_1832: $localize`card restricted at merchant.`,
  declined_by_marqeta_1833: $localize`chip reader malfunction.`,
  declined_by_marqeta_1844: $localize`unexpected error occurred.`,
  declined_by_marqeta_1846: $localize`unauthorized ATM transaction.`,
  declined_by_marqeta_1864: $localize`card used in unauthorized country.`,
  declined_by_marqeta_1874: $localize`invalid expiration date.`,
  declined_by_marqeta_1874_card_frozen: $localize`invalid expiration date. Card frozen.`,
  declined_by_marqeta_1919: $localize`invalid expiration date.`,
  declined_by_marqeta_1901: $localize`card is not activated.`,
  declined_by_marqeta_1920: $localize`card is deactivated.`,
  chip_fallback: $localize`swiping is not supported when a chip reader is available.`,
  reviewable_fraud_suspected: $localize`suspicious activity`,
  soft_decline_review_required: $localize`Auto-declined: unable to verify the cardholder at the time of transaction.`,
  soft_decline_chip_fallback: $localize`Auto-declined: swiping is not supported when a chip reader is available.`,
  soft_decline_vehicle_proximity_mismatch: $localize`Auto-declined: vehicle location data was unreliable at the time of transaction.`,
  soft_decline_fuel_level_exceeds_limit: $localize`Auto-declined: vehicle fuel level data was unreliable at the time of transaction.`,
  soft_decline_expensive_transaction_attempted: $localize`Transaction declined: Less expensive fuel option identified nearby.`,
  soft_decline_review_required_tooltip: $localize`Unable to verify cardholder`,
  high_fraud_risk_score: $localize`suspicious activity detected.`,
  high_fraud_risk_score_card_frozen: $localize`suspicious activity detected. Card frozen.`,
  declined_by_marqeta: $localize`unexpected problem occurred.`,
  invalid_company: $localize`your business is not currently active.`,
  invalid_card: $localize`card is not active or valid.`,
  invalid_merchant: $localize`spend category not authorized.`,
  invalid_merchant_custom: $localize`spend category not authorized.`,
  invalid_merchant_mcc_fuel: $localize`spend authorized for fuel expenses only.`,
  invalid_merchant_mcc_fuel_fleet: $localize`spend authorized for fuel and fleet expenses only.`,
  declined_by_plaid_connection: $localize`issue connecting with bank account.`,
  card_text_auth_locked: $localize`transaction attempted while card was locked`,
  driver_is_deactivated: $localize`deactivated driver`,
  invalid_driver_number: $localize`incorrect driver code.`,
  missing_driver_number: $localize`missing Driver ID prompt.`,
  commando_mode_decline: $localize`unexpected problem occurred`,
  standin_processing_decline: $localize`unexpected problem occurred`,
  gateway_auth_exception: $localize`unexpected problem occurred`,
  vehicle_not_assigned: $localize`no vehicle selected prior to transaction.`,
  blocked_merchant_spend_profile: $localize`location is blocked for cards with this spend profile`,
  blocked_merchant_spend_profile_v2: $localize`transactions at this location are currently blocked for this card.`,
  blocked_merchant_from_policy: $localize`transactions at this location are currently blocked for this card.`,
  blocked_merchant_fleet: $localize`location is blocked for all cards`,
  blocked_merchant_for_card: $localize`merchant blocked for this card.`,
  vehicle_card_locked: $localize`transaction attempted while card was locked.`,
  asset_card_locked: $localize`transaction attempted while card was locked.`,
  card_specific_day_limit_exceeded: $localize`daily spend limit reached.`,
  card_specific_month_limit_exceeded: $localize`monthly spend limit reached.`,
  card_specific_transaction_limit_exceeded: $localize`per transaction limit reached.`,
  invalid_motive_allowed_mcc_or_mid: $localize`spend category or merchant not authorized.`,
  company_specific_day_limit_exceeded: $localize`daily spend limit reached.`,
  company_specific_month_limit_exceeded: $localize`monthly spend limit reached.`,
  company_specific_transaction_limit_exceeded: $localize`per transaction limit reached.`,
  company_specific_cash_transaction_limit_exceeded: $localize`per transaction cash withdrawal limit exceeded.`,
  company_specific_daily_withdrawal_limit_exceeded: $localize`daily cash withdrawal limit reached.`,
  company_specific_monthly_withdrawal_limit_exceeded: $localize`monthly cash withdrawal limit reached.`,
  odometer_not_assigned: $localize`odometer reading not provided prior to transaction.`,
  // custom_field_not_assigned: $localize`Custom Requirement not provided prior to transaction.`, updated seperately due its dynamic nature
  daily_withdrawal_limit_exceeded: $localize`daily cash withdrawal limit reached.`,
  weekly_withdrawal_limit_exceeded: $localize`weekly cash withdrawal limit reached.`,
  atm_withdrawal_disabled: $localize`your card is not permitted to withdraw cash from an ATM.`,
  non_partner_atm_withdrawal_disabled: $localize`your card is not permitted to withdraw cash from a non-partner ATM.`,
  atm_location_restricted: $localize`the transaction was attempted at an unsupported ATM location.`,
  company_withdrawal_credit_exceeded: $localize`company cash advance limit reached for this billing cycle.`,
  restricted_mcc: $localize`restricted item`,
  restricted_mid: $localize`card restricted at merchant`,
  restricted_mid_name_combo: $localize`card restricted at merchant`,
  vehicle_proximity_mismatch: $localize`Auto-declined: vehicle & spend location mismatch`,
  merchant_not_whitelisted_by_fleet: $localize`location not permitted.`,
  online_transactions_disabled: $localize`card can’t be used for online/recurring transactions. Fleet admins can call 1-855-434-3564 to allow them.`,
  category_billing_cycle_credit_exceeded: $localize`billing cycle limit`,
  category_maximum_transaction_amount_exceeded: $localize`per transaction limit`,
  category_day_limit_exceeded: $localize`daily limit`,
  category_week_limit_exceeded: $localize`weekly limit`,
  category_month_limit_exceeded: $localize`monthly limit`,
  auto_declined_fraudulent_transactions: $localize`suspicious activity detected by Motive`,
  auto_declined_fuel_level_above_threshold: $localize`Auto-declined: fuel level above threshold`,
});

export const FleetCardsPaymentFailedReasons: II18nBackendStrings = Object.freeze({
  R01: $localize`Insufficient funds.`,
  R02: $localize`Bank account closed.`,
  R03: $localize`Bank account not found.`,
  R04: $localize`Invalid bank account number.`,
  R05: $localize`Account not authorized for ACH payments.`,
  R06: $localize`Account not authorized for ACH payments.`,
  R07: $localize`Account not authorized for ACH payments.`,
  R08: $localize`Payment stopped.`,
  R09: $localize`Insufficient funds available for payment.`,
  R10: $localize`Account not authorized for ACH payments.`,
  R11: $localize`Account not authorized for ACH payments.`,
  R12: $localize`Account not authorized for ACH payments.`,
  R13: $localize`Invalid routing number.`,
  R14: $localize`Account closed.`,
  R15: $localize`Account not authorized for payments.`,
  R16: $localize`Account not authorized for payments.`,
  R17: $localize`Suspected fraud.`,
  R18: $localize`Internal payment processing error.`,
  R19: $localize`Internal payment processing error.`,
  R20: $localize`Non-Transaction account.`,
  R21: $localize`Internal payment processing error.`,
  R22: $localize`Internal payment processing error.`,
  R23: $localize`Receiver refused credit.`,
  R24: $localize`Duplicate entry.`,
  R25: $localize`Internal payment processing error.`,
  R26: $localize`Internal payment processing error.`,
  R27: $localize`Internal payment processing error.`,
  R28: $localize`Invalid routing number.`,
  R29: $localize`Account not authorized for payments.`,
  R30: $localize`Internal payment processing error.`,
  R31: $localize`Internal payment processing error.`,
  R32: $localize`Internal payment processing error.`,
  R33: $localize`Internal payment processing error.`,
  R34: $localize`Internal payment processing error.`,
  R35: $localize`Account not authorized for payments.`,
  R36: $localize`Account not authorized for payments.`,
  R37: $localize`Internal payment processing error.`,
  R38: $localize`Internal payment processing error.`,
  R39: $localize`Internal payment processing error.`,
  R40: $localize`Internal payment processing error.`,
});

export const HardwareInstallation: II18nBackendStrings = {
  serial_number_placeholder: $localize`Search by serial number`,
  asset_id_placeholder: $localize`Search Asset ID`,
  next: $localize`Next`,
  assign: $localize`Assign`,
  devices: $localize`Devices`,
  asset_gateway: $localize`Asset Gateway`,
  select_sensors: $localize`Select Sensor`,
  select_beacon: $localize`Select Beacon`,
  beacon: $localize`Beacon`,
  env_sensors: $localize`Environmental Sensor`,
  door_and_environmental_sensors: $localize`Door and Env. Sensors`,
  door_sensor: $localize`Door Sensor`,
  assign_new_asset: $localize`Assign to new asset`,
  not_available: $localize`Not Available`,
  assigning_AG_ES: $localize`Assigning...`,
};

export const DVIRStatuses: II18nBackendStrings = {
  no_defect_found: $localize`No Defect Found`,
  no_defect: $localize`No Defect`,
  vehichle_condition_satisfactory: $localize`Vehicle Condition Satisfactory`,
  condition_satisfactory: $localize`Condition Satisfactory`,
};

export const DVIRStatusesSinglePlural: II18nSingularPlural = {
  defect_need_to_be_corrected: { singular: $localize`Defect Need Not Be Corrected`, plural: $localize`Defects Need Not Be Corrected` },
  defect_corrected: { singular: $localize`Defect Corrected`, plural: $localize`Defects Corrected` },
  defect_unknow: { singular: $localize`Defect Status Unknown`, plural: $localize`Defects Status Unknown` },
  defect_open: { singular: $localize`Open Defect`, plural: $localize`Open Defects` },
};

export const AdminAssetTypes: II18nBackendStrings = {
  auto_hauler: $localize`Auto Hauler`,
  box_truck: $localize`Box Truck`,
  conestoga: $localize`Conestoga`,
  construction: $localize`Construction`,
  curtain_side: $localize`Curtain Side`,
  double_drop: $localize`Double Drop`,
  dry_box: $localize`Drybox`,
  dry_van: $localize`Dry Van`,
  dump_tipper: $localize`Dump/Tipper`,
  flatbed: $localize`Flatbed`,
  intermodal_chassis: $localize`Intermodal Chassis`,
  livestock: $localize`Livestock`,
  low_boy: $localize`Lowboy`,
  reefer: $localize`Reefer`,
  removable_gooseneck: $localize`Removable Gooseneck`,
  stake: $localize`Stake`,
  step_deck: $localize`Step Deck`,
  tanker: $localize`Tanker`,
  other: $localize`Other`,
};

export const DispatchContentI18n: II18nBackendStrings = {
  'Pickup': $localize`Pickup`,
  'Delivery': $localize`Delivery`,
  'Route Created': $localize`Route Created`,
  'Special Delivery': $localize`Special Delivery`,
  'Started Dispatch': $localize`Started Dispatch`,
  'Submitted Info Form' : $localize`Submitted Info Form`,
  'Dispatch Sent to Driver': $localize`Dispatch Sent to Driver`,
  'Submitted Depart Form at': $localize`Submitted Depart Form at`,
  'Submitted Arrive Form at': $localize`Submitted Arrive Form at`,
  'Dispatch Completed': $localize`Dispatch Completed`,
  'Dispatch Canceled': $localize`Dispatch Canceled`,
};

// For now, we only have Pickup and Delivery as stop TypeScript
// others are user generated
export const DispatchStopTypesI18n: II18nBackendStrings = {
  'Pickup': $localize`Pickup`,
  'Delivery': $localize`Delivery`,
};

export const AdminWebhooks: II18nBackendStrings = {
  'fault_code_opened': $localize`Fault Code Opened`,
  'fault_code_closed': $localize`Fault Code Closed`,
  'user_upserted': $localize`User Created or Updated`,
  'engine_toggle_event': $localize`Engine On/Off Status`,
  'vehicle_upserted': $localize`Vehicle Created or Updated`,
  'speeding_event_created': $localize`Speeding Event Created`,
  'speeding_event_updated': $localize`Speeding Event Updated`,
  'asset_geofence_event': $localize`Asset Enter/Exit Geofence`,
  'vehicle_geofence_event': $localize`Vehicle Enter/Exit Geofence`,
  'vehicle_location_received': $localize`Vehicle Location Received`,
  'hos_violation_upserted': $localize`HOS Violation Created or Updated`,
  'vehicle_location_updated': $localize`Vehicle Current Location Updated`,
  'inspection_report_upserted': $localize`Inspection Report Created or Updated`,
  'driver_performance_event_created': $localize`Driver Performance Event Created`,
  'driver_performance_event_updated': $localize`Driver Performance Event Updated`,
  'user_duty_status_updated': $localize`User Duty Status Update`,
  'form_entry_upserted': $localize`Dispatch Form Entry Created or Updated`,
};

export const DocumentCategories: II18nBackendStrings = {
  'Other': $localize`Other`,
  'Invoice': $localize`Invoice`,
  'Citation': $localize`Citation`,
  'Manifest': $localize`Manifest`,
  'Packing List': $localize`Packing List`,
  'Fuel Receipt': $localize`Fuel Receipt`,
  'Scale Ticket': $localize`Scale Ticket`,
  'Crash Report': $localize`Crash Report`,
  'Signed Pickup': $localize`Signed Pickup`,
  'Crash Report 2': $localize`Crash Report 2`,
  'Other Document': $localize`Other Document`,
  'Accident Photo': $localize`Accident Photo`,
  'Bill Of Lading': $localize`Bill Of Lading`,
  'Signed Delivery': $localize`Signed Delivery`,
  'Default Expense Receipt': $localize`Default Expense Receipt`,
};
